var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { CircularProgress, useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import React, { useEffect, useState } from 'react';
import { Config } from '../../../api/config';
import { AllEstimateUrl, getAlertsByJobCardIdURL, getCustomerComplaintPriceUrl, getDownloadPreJobCardDocumentAttachmentUrl, getEstimateAdditionalDetailByEstimateIdUrl, getPrecheckListByInstallBaseIdUrl, getProxyProfileContactDetailsUrl, precheckDynamicCheckListFormUrl, productAttributeValueUrl } from '../../../api/url';
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { getLoadingKey } from '../../../builderPackage/common/commonFunctions';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { APISchema, ESystemName, LOCAL_STORAGE_KEYS } from '../../../constants';
import { downloadAttachment, showNotification } from '../../../redux/commonSlice';
import { getByIdAPI, getListAPI } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { dateFormate } from '../../../utils/utils';
import { getCustomerDetailsAPI } from '../../contractSaleInvoice/services/apiCall';
import { ContractInvoiceKeys } from '../../contractSaleInvoice/services/entity';
import { serviceHistoryAPI } from '../../vehicleHistory/service/apiCall';
import { getInstallbaseContractAPI } from '../services/apiCall';
import { CustomerVoiceColumns, estimationColumns, formatAddressMultiline, getFinalInspectorName, getLatestContractByKey, getLogoByChannel, LabourColumns, last2VisitColumns, loadBase64FromImportedImage, PartColumns, scissorImageBase64, scissorRightImageBase64, truncateAddress, truncateTextWithLines } from '../services/entity';
var SourceItem_E = /*#__PURE__*/ function (SourceItem_E) {
    SourceItem_E["partSource"] = "partSource";
    SourceItem_E["labourSource"] = "labourSource";
    return SourceItem_E;
}(SourceItem_E || {});
export var CombineJCPrint = function (_ref) {
    var _AllDataEstimate$data, _data$partDetails, _data$labourDetails, _installbaseDetailsBy, _data$NPSResponse, _data$NPSResponse2;
    var data = _ref.data, onClose = _ref.onClose;
    var dispatch = useAppDispatch();
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var SELECTED_CHANNEL = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var orgnizationTimings = getLocalStorageItem(LOCAL_STORAGE_KEYS.ORGANIZATION_TIMING);
    var BYCHANNELID = getLocalStorageItem("ByChannelId");
    var _a = useAppSelector(function (state) { return state.crud; }), installbaseDetailsById = _a.installbaseDetailsById, AllDataEstimate = _a.AllDataEstimate, answerResponse = _a.answerResponse, getContactDetailsData = _a.getContactDetailsData;
    var _b = useState(), customer = _b[0], setCustomer = _b[1];
    var _c = useState([]), imageViewTypesTabs = _c[0], setImageViewTypesTabs = _c[1];
    var EstimateDetails = (AllDataEstimate === null || AllDataEstimate === void 0 || (_AllDataEstimate$data = AllDataEstimate.data) === null || _AllDataEstimate$data === void 0 || (_AllDataEstimate$data = _AllDataEstimate$data.OriginalEstimate) === null || _AllDataEstimate$data === void 0 ? void 0 : _AllDataEstimate$data[0]) || {};
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var _d = useState([]), lastTwoServices = _d[0], setLastTwoServices = _d[1];
    var _e = useState(), customerSignature = _e[0], setCustomerSignature = _e[1];
    var _f = useState([]), fuelIdicatorDynamicList = _f[0], setFuelIndicatorDynamicList = _f[1];
    var _g = useState([]), BatteryDynamicList = _g[0], setBatteryDynamicList = _g[1];
    var _h = useState(), installbaseContracts = _h[0], setInstallbaseContracts = _h[1];
    var _j = useState([]), alertsList = _j[0], setAlertsList = _j[1];
    var _k = useState([]), customerComplsints = _k[0], setCustomerComplsints = _k[1];
    var totalAmountPart = data === null || data === void 0 || (_data$partDetails = data.partDetails) === null || _data$partDetails === void 0 ? void 0 : _data$partDetails.reduce(function (total, item) { return total + (parseFloat(item === null || item === void 0 ? void 0 : item.Amount) || 0); }, 0);
    var totalAmountLabour = data === null || data === void 0 || (_data$labourDetails = data.labourDetails) === null || _data$labourDetails === void 0 ? void 0 : _data$labourDetails.reduce(function (total, item) { return total + (parseFloat(item === null || item === void 0 ? void 0 : item.Amount) || 0); }, 0);
    var customerComplaintPartTotal = customerComplsints === null || customerComplsints === void 0 ? void 0 : customerComplsints.reduce(function (total, item) { return total + (parseFloat(item === null || item === void 0 ? void 0 : item.PartPrice) || 0); }, 0);
    var customerComplaintLabourTotal = customerComplsints === null || customerComplsints === void 0 ? void 0 : customerComplsints.reduce(function (total, item) { return total + (parseFloat(item === null || item === void 0 ? void 0 : item.LabourPrice) || 0); }, 0);
    var PartAndLabourTotal = (totalAmountPart + totalAmountLabour).toFixed(2);
    var EstimatePartTotal = totalAmountPart + customerComplaintPartTotal;
    var EstimateLabourTotal = totalAmountLabour + customerComplaintLabourTotal;
    var GrandTotal = (EstimatePartTotal + EstimateLabourTotal).toFixed(2);
    var _l = useState({}), fuelResponses = _l[0], setFuelResponses = _l[1];
    var _m = useState([]), questions = _m[0], setQuestions = _m[1];
    var _o = useState(''), saObservation = _o[0], setSAObservation = _o[1];
    var _p = useState(''), logoBase64 = _p[0], setLogoBase64 = _p[1];
    var TotalKMReading = (parseInt(installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy = installbaseDetailsById.data) === null || _installbaseDetailsBy === void 0 ? void 0 : _installbaseDetailsBy.MeterChangeReading) || 0) + (parseInt(data === null || data === void 0 ? void 0 : data.ODOMeterReading) || 0);
    var finalInspector = getFinalInspectorName(data === null || data === void 0 ? void 0 : data.FinalInspector);
    var crud = useAppSelector(function (state) { return state.crud; });
    var isRevisited = alertsList.some(function (data) { return data.AlertName === 'Repeat'; });
    var result = [];
    var posMap = {
        Left: "L",
        Top: "T",
        Right: "R"
    };
    var isSearchLoading = [crud[getLoadingKey('installbaseDetailsById')], crud[getLoadingKey('AllDataEstimate')], crud[getLoadingKey('estimateAdditionalDetails')], crud[getLoadingKey('answerResponse')], crud[getLoadingKey('precheckResult')], crud[getLoadingKey(ContractInvoiceKeys.CustomerDetailsKey)]].includes('loading');
    var timeZone = 'Asia/Kolkata';
    var startFormatted = dayjs.utc(orgnizationTimings === null || orgnizationTimings === void 0 ? void 0 : orgnizationTimings.StartDateTime).tz(timeZone).format('h A');
    var endFormatted = dayjs.utc(orgnizationTimings === null || orgnizationTimings === void 0 ? void 0 : orgnizationTimings.EndDateTime).tz(timeZone).format('h A');
    var checklistItems = [];
    var organizationAddress;
    if (selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.OrganizationAddress) {
        organizationAddress = formatAddressMultiline(selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationAddress);
    }
    useEffect(function () {
        if (answerResponse && fuelIdicatorDynamicList) {
            var _answerResponse$data, _fuelIdicatorDynamicL;
            var responseMap_1 = {};
            if (Array.isArray(answerResponse === null || answerResponse === void 0 || (_answerResponse$data = answerResponse.data) === null || _answerResponse$data === void 0 ? void 0 : _answerResponse$data.Options)) {
                var _answerResponse$data2;
                answerResponse === null || answerResponse === void 0 || (_answerResponse$data2 = answerResponse.data) === null || _answerResponse$data2 === void 0 || (_answerResponse$data2 = _answerResponse$data2.Options) === null || _answerResponse$data2 === void 0 || _answerResponse$data2.forEach(function (option) {
                    responseMap_1[option === null || option === void 0 ? void 0 : option.QuestionId] = option === null || option === void 0 ? void 0 : option.ResponseValue;
                });
            }
            var responses_1 = {};
            if (Array.isArray(fuelIdicatorDynamicList === null || fuelIdicatorDynamicList === void 0 || (_fuelIdicatorDynamicL = fuelIdicatorDynamicList[0]) === null || _fuelIdicatorDynamicL === void 0 ? void 0 : _fuelIdicatorDynamicL.Questions)) {
                var _fuelIdicatorDynamicL2;
                fuelIdicatorDynamicList === null || fuelIdicatorDynamicList === void 0 || (_fuelIdicatorDynamicL2 = fuelIdicatorDynamicList[0]) === null || _fuelIdicatorDynamicL2 === void 0 || (_fuelIdicatorDynamicL2 = _fuelIdicatorDynamicL2.Questions) === null || _fuelIdicatorDynamicL2 === void 0 || _fuelIdicatorDynamicL2.forEach(function (question) {
                    var title = question === null || question === void 0 ? void 0 : question.Title;
                    var qid = question === null || question === void 0 ? void 0 : question.QuestionId;
                    if (responseMap_1[qid] !== undefined) {
                        responses_1[title] = responseMap_1[qid];
                    }
                });
            }
            setFuelResponses(responses_1);
        }
        if (answerResponse) {
            getDynamicCheckListFormQuestions();
        }
    }, [answerResponse, fuelIdicatorDynamicList]);
    var getNPSCategory = function (rating) {
        if (rating == null)
            return "";
        if (rating >= 9 && rating <= 10)
            return "Promoter";
        if (rating >= 7 && rating <= 8)
            return "Passive";
        if (rating >= 0 && rating <= 6)
            return "Detractor";
        return "";
    };
    var rating = data !== null && data !== void 0 && (_data$NPSResponse = data.NPSResponse) !== null && _data$NPSResponse !== void 0 && _data$NPSResponse.length ? (_data$NPSResponse2 = data.NPSResponse) === null || _data$NPSResponse2 === void 0 || (_data$NPSResponse2 = _data$NPSResponse2[0]) === null || _data$NPSResponse2 === void 0 ? void 0 : _data$NPSResponse2.AnswerRating : null;
    var category = getNPSCategory(rating);
    if (Array.isArray(imageViewTypesTabs)) {
        imageViewTypesTabs === null || imageViewTypesTabs === void 0 || imageViewTypesTabs.forEach(function (section) {
            if (Array.isArray(section === null || section === void 0 ? void 0 : section.checkListItems)) {
                var _section$checkListIte;
                section === null || section === void 0 || (_section$checkListIte = section.checkListItems) === null || _section$checkListIte === void 0 || _section$checkListIte.forEach(function (item) {
                    var _item$Answers;
                    var trueAnswer = item === null || item === void 0 || (_item$Answers = item.Answers) === null || _item$Answers === void 0 ? void 0 : _item$Answers.find(function (ans) { return ans.defaultValue === true; });
                    if (trueAnswer) {
                        checklistItems.push(_objectSpread(_objectSpread({}, item), {}, {
                            name: item === null || item === void 0 ? void 0 : item.Question,
                            position: section === null || section === void 0 ? void 0 : section.Name,
                            mark: trueAnswer === null || trueAnswer === void 0 ? void 0 : trueAnswer.Key
                        }));
                    }
                });
            }
        });
    }
    var matchQuestionsWithAnswers = function (questions, answers) {
        return questions === null || questions === void 0 ? void 0 : questions.map(function (q) {
            var match = answers === null || answers === void 0 ? void 0 : answers.find(function (ans) {
                // ans.name.trim().toLowerCase() === q.Question.trim().toLowerCase()
                return ans.ProductConditionCheckListItemId === q.ProductConditionCheckListItemId;
            });
            return {
                name: q.Question,
                pos: match ? match.position.trim().charAt(0).toUpperCase() : '',
                mark: match ? match.mark.trim().charAt(0).toUpperCase() : ''
            };
        });
    };
    var groupedItemsMap = new Map();
    var allItems = matchQuestionsWithAnswers(questions, checklistItems);
    allItems === null || allItems === void 0 || allItems.forEach(function (_ref2) {
        var name = _ref2.name, pos = _ref2.pos, mark = _ref2.mark;
        if (!groupedItemsMap.has(name)) {
            groupedItemsMap.set(name, {
                name: name
            });
        }
        var current = groupedItemsMap.get(name);
        current[pos] = mark;
    });
    var mergedItems = Array.from(groupedItemsMap.values());
    mergedItems === null || mergedItems === void 0 || mergedItems.sort(function (a, b) {
        var _a$name, _b$name;
        var nameA = ((_a$name = a.name) === null || _a$name === void 0 ? void 0 : _a$name.toLowerCase()) || "";
        var nameB = ((_b$name = b.name) === null || _b$name === void 0 ? void 0 : _b$name.toLowerCase()) || "";
        return nameA.localeCompare(nameB);
    });
    var mid = Math === null || Math === void 0 ? void 0 : Math.ceil((mergedItems === null || mergedItems === void 0 ? void 0 : mergedItems.length) / 2);
    var itemsLeft = mergedItems === null || mergedItems === void 0 ? void 0 : mergedItems.slice(0, mid);
    var itemsRight = mergedItems === null || mergedItems === void 0 ? void 0 : mergedItems.slice(mid);
    // const allItems = matchQuestionsWithAnswers(questions, checklistItems);
    // const itemsLeft = allItems.filter((_, index) => index % 2 === 0);
    // const itemsRight = allItems.filter((_, index) => index % 2 !== 0);
    useEffect(function () {
        var channelName = SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName;
        var logo = getLogoByChannel(channelName);
        loadBase64FromImportedImage(logo).then(setLogoBase64);
        var fetchCustomerDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _response$payload, customerDetails, _customerData$Person, _customerData$Person2, _customerData$PersonC, _customerData$Address, _customerData$Address2, _customerData$Address3, _customerData$Address4, customerData, customerDetail, request, response, _response$payload2, _response$payload3, _res$payload, res, _res$payload2, additionalDetails, base64, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(data !== null && data !== void 0 && data.CustomerId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getCustomerDetailsAPI({
                                request: {
                                    id: data === null || data === void 0 ? void 0 : data.CustomerId
                                }
                            })];
                    case 1:
                        customerDetails = _a.sent();
                        if (customerDetails !== null && customerDetails !== void 0 && customerDetails.success) {
                            customerData = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.data;
                            customerDetail = {
                                PersonName: "".concat((customerData === null || customerData === void 0 || (_customerData$Person = customerData.Person) === null || _customerData$Person === void 0 ? void 0 : _customerData$Person.GivenName) || '', " ").concat((customerData === null || customerData === void 0 || (_customerData$Person2 = customerData.Person) === null || _customerData$Person2 === void 0 ? void 0 : _customerData$Person2.FamilyName) || '').trim(),
                                PrimaryContact: (customerData === null || customerData === void 0 || (_customerData$PersonC = customerData.PersonContact) === null || _customerData$PersonC === void 0 ? void 0 : _customerData$PersonC.find(function (contact) { return (contact === null || contact === void 0 ? void 0 : contact.ContactType) === "Primary"; })) || null,
                                Address: [customerData === null || customerData === void 0 || (_customerData$Address = customerData.Address) === null || _customerData$Address === void 0 || (_customerData$Address = _customerData$Address[0]) === null || _customerData$Address === void 0 ? void 0 : _customerData$Address.Address1, customerData === null || customerData === void 0 || (_customerData$Address2 = customerData.Address) === null || _customerData$Address2 === void 0 || (_customerData$Address2 = _customerData$Address2[0]) === null || _customerData$Address2 === void 0 ? void 0 : _customerData$Address2.Address2, customerData === null || customerData === void 0 || (_customerData$Address3 = customerData.Address) === null || _customerData$Address3 === void 0 || (_customerData$Address3 = _customerData$Address3[0]) === null || _customerData$Address3 === void 0 ? void 0 : _customerData$Address3.Address3, customerData === null || customerData === void 0 || (_customerData$Address4 = customerData.Address) === null || _customerData$Address4 === void 0 || (_customerData$Address4 = _customerData$Address4[0]) === null || _customerData$Address4 === void 0 ? void 0 : _customerData$Address4.Address4].filter(Boolean).join(', ')
                            };
                            setCustomer(customerDetail);
                        }
                        _a.label = 2;
                    case 2:
                        request = {
                            JobCardId: data === null || data === void 0 ? void 0 : data.JobCardId
                        };
                        return [4 /*yield*/, dispatch(getByIdAPI({
                                key: "AllDataEstimate",
                                url: AllEstimateUrl,
                                request: request
                            }))];
                    case 3:
                        response = _a.sent();
                        if (!(response !== null && response !== void 0 && (_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.value) !== null && _response$payload !== void 0 && _response$payload.success)) return [3 /*break*/, 8];
                        response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.OriginalEstimate) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2[0]) === null || _response$payload2 === void 0 || _response$payload2.id;
                        return [4 /*yield*/, dispatch(getByIdAPI({
                                key: "estimateAdditionalDetails",
                                url: getEstimateAdditionalDetailByEstimateIdUrl,
                                request: {
                                    EstimateId: response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.value) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.data) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.OriginalEstimate) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3[0]) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.id
                                }
                            }))];
                    case 4:
                        res = _a.sent();
                        if (!(res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && (_res$payload = _res$payload.value) !== null && _res$payload !== void 0 && _res$payload.success)) return [3 /*break*/, 8];
                        additionalDetails = res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.value) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.data;
                        if (!(additionalDetails !== null && additionalDetails !== void 0 && additionalDetails.AttachmentId && additionalDetails !== null && additionalDetails !== void 0 && additionalDetails.PreJobCardDocumentAttachmentId)) return [3 /*break*/, 8];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, downloadAttachment(additionalDetails === null || additionalDetails === void 0 ? void 0 : additionalDetails.AttachmentId, additionalDetails === null || additionalDetails === void 0 ? void 0 : additionalDetails.PreJobCardDocumentAttachmentId, getDownloadPreJobCardDocumentAttachmentUrl)];
                    case 6:
                        base64 = _a.sent();
                        setCustomerSignature(base64);
                        return [3 /*break*/, 8];
                    case 7:
                        error_1 = _a.sent();
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Error downloading attachment",
                            type: "error"
                        }));
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        fetchCustomerDetails();
        getPrecheckList();
        fetchVehicleHistory();
        getPrecheckAnswersByModelId();
        getFuelLevel();
        getJobCardAlerts();
        getCustomerComplaints();
        getSAObservation();
        getContactDetails();
        getInstallbaseContracts();
    }, []);
    var getInstallbaseContracts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, contracts, latestAMCContract, latestATWContract;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getInstallbaseContractAPI({
                        request: {
                            InstallBaseId: data === null || data === void 0 ? void 0 : data.InstallBaseId
                        }
                    })];
                case 1:
                    res = _a.sent();
                    contracts = (res === null || res === void 0 ? void 0 : res.data) || [];
                    latestAMCContract = getLatestContractByKey("AMC", BYCHANNELID, contracts);
                    latestATWContract = getLatestContractByKey("ATW/EW", BYCHANNELID, contracts);
                    setInstallbaseContracts({
                        AMCExpiryDate: latestAMCContract === null || latestAMCContract === void 0 ? void 0 : latestAMCContract.EffectiveTo,
                        ATWExpiryDate: latestATWContract === null || latestATWContract === void 0 ? void 0 : latestATWContract.EffectiveTo
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var getContactDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: "getContactDetailsData",
                        url: getProxyProfileContactDetailsUrl
                    }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getSAObservation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _responseData$payload, responseData, _responseData$payload2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: '',
                        url: "".concat(Config.baseURL, "PreJobCardDocument/").concat(data === null || data === void 0 ? void 0 : data.ParentId, "/SAPreCheckComments")
                    }))];
                case 1:
                    responseData = _a.sent();
                    if (responseData !== null && responseData !== void 0 && (_responseData$payload = responseData.payload) !== null && _responseData$payload !== void 0 && _responseData$payload.success) {
                        setSAObservation(responseData === null || responseData === void 0 || (_responseData$payload2 = responseData.payload) === null || _responseData$payload2 === void 0 || (_responseData$payload2 = _responseData$payload2.data) === null || _responseData$payload2 === void 0 || (_responseData$payload2 = _responseData$payload2.SAComments) === null || _responseData$payload2 === void 0 ? void 0 : _responseData$payload2.Comments);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getCustomerComplaints = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _res$payload3, priceMap, res, _res$payload4, _data$CustomerComplai, priceMap_1, _res$payload5, complaintSourceMap_1, enrichedDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    priceMap = {};
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getCustomerComplaintPriceUrl,
                            request: {
                                EstimateId: data === null || data === void 0 ? void 0 : data.ParentId
                            }
                        }))];
                case 1:
                    res = _a.sent();
                    if (res !== null && res !== void 0 && (_res$payload3 = res.payload) !== null && _res$payload3 !== void 0 && _res$payload3.success) {
                        priceMap_1 = {};
                        if (Array.isArray(res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.data)) {
                            res === null || res === void 0 || (_res$payload5 = res.payload) === null || _res$payload5 === void 0 || (_res$payload5 = _res$payload5.data) === null || _res$payload5 === void 0 || _res$payload5.forEach(function (item) {
                                priceMap_1[item === null || item === void 0 ? void 0 : item.ComplaintId] = {
                                    PartPrice: parseFloat((item === null || item === void 0 ? void 0 : item.PartPrice) || '0').toFixed(2),
                                    LabourPrice: parseFloat((item === null || item === void 0 ? void 0 : item.LabourPrice) || '0').toFixed(2)
                                };
                            });
                        }
                        complaintSourceMap_1 = {
                            1: 'Customer Voice',
                            2: 'Road Test'
                        };
                        enrichedDetails = data === null || data === void 0 || (_data$CustomerComplai = data.CustomerComplaints) === null || _data$CustomerComplai === void 0 ? void 0 : _data$CustomerComplai.map(function (item, index) {
                            var priceInfo = priceMap_1[item === null || item === void 0 ? void 0 : item.ComplaintId];
                            var partPrice = priceInfo ? parseFloat(priceInfo.PartPrice) : 0;
                            var labourPrice = priceInfo ? parseFloat(priceInfo.LabourPrice) : 0;
                            var hasPrice = partPrice > 0 || labourPrice > 0;
                            return _objectSpread(_objectSpread({}, item), {}, {
                                srNo: index + 1,
                                PartPrice: partPrice > 0 ? partPrice.toFixed(2) : '0.00',
                                LabourPrice: labourPrice > 0 ? labourPrice.toFixed(2) : '0.00',
                                TotalPrice: hasPrice ? (partPrice + labourPrice).toFixed(2) : '0.00',
                                source: complaintSourceMap_1[item === null || item === void 0 ? void 0 : item.Value] || ''
                            });
                        });
                        setCustomerComplsints(enrichedDetails);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getJobCardAlerts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _data$Key, _result$payload, _result$payload2, _result$payload3, requestBody, result, _result$payload4, _UpdatedList, UpdatedList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        SystemName: (_data$Key = data === null || data === void 0 ? void 0 : data.Key) !== null && _data$Key !== void 0 ? _data$Key : null,
                        InstallBaseId: data === null || data === void 0 ? void 0 : data.InstallBaseId
                    };
                    requestBody.ParentId = data === null || data === void 0 ? void 0 : data.jobCardId;
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: 'getAlertsByJobCardId',
                            url: getAlertsByJobCardIdURL,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data && result !== null && result !== void 0 && (_result$payload3 = result.payload) !== null && _result$payload3 !== void 0 && (_result$payload3 = _result$payload3.value) !== null && _result$payload3 !== void 0 && (_result$payload3 = _result$payload3.data) !== null && _result$payload3 !== void 0 && _result$payload3.Alerts) {
                        UpdatedList = __spreadArray([], (result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.value) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.data) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.Alerts), true);
                        UpdatedList = (_UpdatedList = UpdatedList) === null || _UpdatedList === void 0 ? void 0 : _UpdatedList.map(function (item, index) {
                            if (index === 0) {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    isExpanded: true
                                });
                            }
                            else {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    isExpanded: false
                                });
                            }
                        });
                        setAlertsList(UpdatedList);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchVehicleHistory = function () { return __awaiter(void 0, void 0, void 0, function () {
        var serviceHistory, _serviceHistory$data, latestTwoServices;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, serviceHistoryAPI({
                        request: {
                            InstallBaseId: data === null || data === void 0 ? void 0 : data.InstallBaseId
                        }
                    })];
                case 1:
                    serviceHistory = _a.sent();
                    if (serviceHistory !== null && serviceHistory !== void 0 && serviceHistory.success) {
                        latestTwoServices = (serviceHistory === null || serviceHistory === void 0 || (_serviceHistory$data = serviceHistory.data) === null || _serviceHistory$data === void 0 || (_serviceHistory$data = _serviceHistory$data.ServiceDetails) === null || _serviceHistory$data === void 0 || (_serviceHistory$data = _serviceHistory$data.slice()) === null || _serviceHistory$data === void 0 || (_serviceHistory$data = _serviceHistory$data.sort(function (a, b) { return new Date(b === null || b === void 0 ? void 0 : b.DocDate).getTime() - new Date(a === null || a === void 0 ? void 0 : a.DocDate).getTime(); })) === null || _serviceHistory$data === void 0 || (_serviceHistory$data = _serviceHistory$data.slice(0, 2)) === null || _serviceHistory$data === void 0 ? void 0 : _serviceHistory$data.map(function (service) { return _objectSpread(_objectSpread({}, service), {}, {
                            DocDate: service !== null && service !== void 0 && service.DocDate ? dayjs(service === null || service === void 0 ? void 0 : service.DocDate).format('DD MMM, YYYY') : ''
                        }); })) || [];
                        while (latestTwoServices.length < 2) {
                            latestTwoServices.push({});
                        }
                        console.log('latestTwoServices', latestTwoServices);
                        setLastTwoServices(latestTwoServices);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getPrecheckList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var precheckListResult, _precheckListResult$p, _precheckListResult$p2, _data$ProductConditio, mastersItemsList, AlhpabeticallySortedMasterList, savedItemsList_1, newArray_1, viewIdMap_1, data_1, _data$ProductConditio2, downloadImagePromise, final, groupedItemsMap_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: "",
                        url: getPrecheckListByInstallBaseIdUrl(data === null || data === void 0 ? void 0 : data.ProductId)
                    }))];
                case 1:
                    precheckListResult = _a.sent();
                    if (!(precheckListResult !== null && precheckListResult !== void 0 && precheckListResult.payload.success && precheckListResult !== null && precheckListResult !== void 0 && precheckListResult.payload.data)) return [3 /*break*/, 4];
                    mastersItemsList = precheckListResult !== null && precheckListResult !== void 0 && (_precheckListResult$p = precheckListResult.payload) !== null && _precheckListResult$p !== void 0 && (_precheckListResult$p = _precheckListResult$p.data) !== null && _precheckListResult$p !== void 0 && _precheckListResult$p.ProductConditionCheckListItemList ? __spreadArray([], (precheckListResult === null || precheckListResult === void 0 || (_precheckListResult$p2 = precheckListResult.payload) === null || _precheckListResult$p2 === void 0 || (_precheckListResult$p2 = _precheckListResult$p2.data) === null || _precheckListResult$p2 === void 0 ? void 0 : _precheckListResult$p2.ProductConditionCheckListItemList), true) : [];
                    AlhpabeticallySortedMasterList = mastersItemsList.sort(function (a, b) { return a.Question.localeCompare(b.Question); });
                    setQuestions(AlhpabeticallySortedMasterList);
                    return [4 /*yield*/, getProductContitionValues()];
                case 2:
                    savedItemsList_1 = _a.sent();
                    newArray_1 = [];
                    if (Array.isArray(AlhpabeticallySortedMasterList)) {
                        AlhpabeticallySortedMasterList === null || AlhpabeticallySortedMasterList === void 0 || AlhpabeticallySortedMasterList.forEach(function (item) {
                            var exists = savedItemsList_1 === null || savedItemsList_1 === void 0 ? void 0 : savedItemsList_1.some(function (existItem) { return existItem.ProductConditionCheckListItemId === item.ProductConditionCheckListItemId; });
                            if (exists) {
                                var _item$Answers2;
                                var matchedReqItem_1 = savedItemsList_1 === null || savedItemsList_1 === void 0 ? void 0 : savedItemsList_1.find(function (existItem) { return existItem.ProductConditionCheckListItemId === item.ProductConditionCheckListItemId; });
                                var images = [];
                                var newItem = {
                                    "ProductConditionCheckListItemId": item === null || item === void 0 ? void 0 : item.ProductConditionCheckListItemId,
                                    "Question": item === null || item === void 0 ? void 0 : item.Question,
                                    "Answers": item === null || item === void 0 || (_item$Answers2 = item.Answers) === null || _item$Answers2 === void 0 ? void 0 : _item$Answers2.map(function (answer) { return _objectSpread(_objectSpread({}, answer), {}, {
                                        defaultValue: answer.Key === matchedReqItem_1.AnswerKey
                                    }); }),
                                    "ImageXPostion": item === null || item === void 0 ? void 0 : item.ImageXPostion,
                                    "ImageYPostion": item === null || item === void 0 ? void 0 : item.ImageYPostion,
                                    "ProductConditionCheckListId": item === null || item === void 0 ? void 0 : item.ProductConditionCheckListId,
                                    "ProductConditionViewId": item === null || item === void 0 ? void 0 : item.ProductConditionViewId,
                                    "Remark": matchedReqItem_1.Remarks,
                                    images: images
                                };
                                newArray_1.push(newItem);
                            }
                            else {
                                newArray_1.push(item);
                            }
                        });
                    }
                    viewIdMap_1 = {};
                    data_1 = precheckListResult === null || precheckListResult === void 0 ? void 0 : precheckListResult.payload.data;
                    if (Array.isArray(newArray_1)) {
                        newArray_1 === null || newArray_1 === void 0 || newArray_1.forEach(function (item) {
                            var viewId = item === null || item === void 0 ? void 0 : item.ProductConditionViewId;
                            if (viewId) {
                                if (!viewIdMap_1[viewId]) {
                                    viewIdMap_1[viewId] = [];
                                }
                                viewIdMap_1[viewId].push(item);
                            }
                        });
                    }
                    if (!(data_1 !== null && data_1 !== void 0 && data_1.ProductConditionViewList && Array.isArray(data_1 === null || data_1 === void 0 ? void 0 : data_1.ProductConditionViewList) && (data_1 === null || data_1 === void 0 || (_data$ProductConditio = data_1.ProductConditionViewList) === null || _data$ProductConditio === void 0 ? void 0 : _data$ProductConditio.length) > 0)) return [3 /*break*/, 4];
                    downloadImagePromise = data_1 === null || data_1 === void 0 || (_data$ProductConditio2 = data_1.ProductConditionViewList) === null || _data$ProductConditio2 === void 0 ? void 0 : _data$ProductConditio2.map(function (viewItem) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, _objectSpread(_objectSpread({}, viewItem), {}, {
                                    checkListItems: viewIdMap_1[viewItem.ProductConditionViewId] || []
                                })];
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(downloadImagePromise)];
                case 3:
                    final = _a.sent();
                    final === null || final === void 0 || final.forEach(function (section) {
                        var pos = posMap[section.Name] || "";
                        if (Array.isArray(section.checkListItems)) {
                            var _section$checkListIte2;
                            (_section$checkListIte2 = section.checkListItems) === null || _section$checkListIte2 === void 0 || _section$checkListIte2.forEach(function (item) {
                                var trueAnswer = item.Answers.find(function (a) { return a.defaultValue === true; });
                                if (trueAnswer) {
                                    var mark = "";
                                    if (trueAnswer.Key === "Damage")
                                        mark = "D";
                                    else if (trueAnswer.Key === "Scratch")
                                        mark = "S";
                                    else if (trueAnswer.Key === "Missing")
                                        mark = "M";
                                    result.push({
                                        name: item.Question,
                                        pos: pos,
                                        mark: mark
                                    });
                                }
                            });
                        }
                    });
                    setImageViewTypesTabs(final);
                    groupedItemsMap_1 = new Map();
                    result.forEach(function (_ref3) {
                        var name = _ref3.name, pos = _ref3.pos, mark = _ref3.mark;
                        if (!groupedItemsMap_1.has(name)) {
                            groupedItemsMap_1.set(name, {
                                name: name
                            });
                        }
                        var current = groupedItemsMap_1.get(name);
                        current[pos] = mark;
                    });
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getProductContitionValues = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _data$ParentId, _precheckListResult$p3, updatedPayload, precheckListResult, _precheckListResult$p4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedPayload = {
                        EstimateId: (_data$ParentId = data === null || data === void 0 ? void 0 : data.ParentId) !== null && _data$ParentId !== void 0 ? _data$ParentId : "",
                        SystemName: "ProductConditionCheckListItem"
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "precheckResult",
                            url: "".concat(Config.baseURL + APISchema.Estimate, "/InspectionProductContitionValues"),
                            request: updatedPayload
                        }))];
                case 1:
                    precheckListResult = _a.sent();
                    if (precheckListResult !== null && precheckListResult !== void 0 && (_precheckListResult$p3 = precheckListResult.payload) !== null && _precheckListResult$p3 !== void 0 && (_precheckListResult$p3 = _precheckListResult$p3.value) !== null && _precheckListResult$p3 !== void 0 && _precheckListResult$p3.success) {
                        return [2 /*return*/, precheckListResult === null || precheckListResult === void 0 || (_precheckListResult$p4 = precheckListResult.payload) === null || _precheckListResult$p4 === void 0 || (_precheckListResult$p4 = _precheckListResult$p4.value) === null || _precheckListResult$p4 === void 0 || (_precheckListResult$p4 = _precheckListResult$p4.data) === null || _precheckListResult$p4 === void 0 ? void 0 : _precheckListResult$p4.InspectionValues];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getPrecheckAnswersByModelId = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _data$ParentId2, requestBody, answersResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        EstimateId: (_data$ParentId2 = data === null || data === void 0 ? void 0 : data.ParentId) !== null && _data$ParentId2 !== void 0 ? _data$ParentId2 : ""
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "answerResponse",
                            url: "".concat(Config.baseURL + 'Estimate', "/InspectionPreCheckList"),
                            request: requestBody
                        }))];
                case 1:
                    answersResponse = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getDynamicCheckListFormQuestions = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _QuestionsResponse$pa, requestBody, QuestionsResponse, _QuestionsResponse$pa2, QuestionsList, result_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "SystemName": ESystemName.Estimate,
                        "ProductId": data === null || data === void 0 ? void 0 : data.ProductId,
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: requestBody
                        }))];
                case 1:
                    QuestionsResponse = _a.sent();
                    if (QuestionsResponse !== null && QuestionsResponse !== void 0 && (_QuestionsResponse$pa = QuestionsResponse.payload) !== null && _QuestionsResponse$pa !== void 0 && (_QuestionsResponse$pa = _QuestionsResponse$pa.value) !== null && _QuestionsResponse$pa !== void 0 && _QuestionsResponse$pa.success) {
                        QuestionsList = (_QuestionsResponse$pa2 = QuestionsResponse.payload.value.data) !== null && _QuestionsResponse$pa2 !== void 0 ? _QuestionsResponse$pa2 : [];
                        result_1 = QuestionsList.filter(function (group) { return typeof (group === null || group === void 0 ? void 0 : group.QuestionGroupName) === 'string' && group.QuestionGroupName.toLowerCase().includes('battery'); }).map(function (questionGroupItem) {
                            var _questionGroupItem$Qu;
                            if (Array.isArray(questionGroupItem === null || questionGroupItem === void 0 ? void 0 : questionGroupItem.Questions) && (questionGroupItem === null || questionGroupItem === void 0 || (_questionGroupItem$Qu = questionGroupItem.Questions) === null || _questionGroupItem$Qu === void 0 ? void 0 : _questionGroupItem$Qu.length) > 0) {
                                var SortedQuestionsBySequence = __spreadArray([], questionGroupItem.Questions, true).sort(function (a, b) {
                                    var _a$Sequence, _b$Sequence;
                                    return ((_a$Sequence = a === null || a === void 0 ? void 0 : a.Sequence) !== null && _a$Sequence !== void 0 ? _a$Sequence : 0) - ((_b$Sequence = b === null || b === void 0 ? void 0 : b.Sequence) !== null && _b$Sequence !== void 0 ? _b$Sequence : 0);
                                });
                                return _objectSpread(_objectSpread({}, questionGroupItem), {}, {
                                    Questions: SortedQuestionsBySequence === null || SortedQuestionsBySequence === void 0 ? void 0 : SortedQuestionsBySequence.map(function (questionItem, index) {
                                        var _answerResponse$data$, _answerResponse$data3, _questionAnswerItem$R;
                                        var answerResponseData = (_answerResponse$data$ = answerResponse === null || answerResponse === void 0 || (_answerResponse$data3 = answerResponse.data) === null || _answerResponse$data3 === void 0 ? void 0 : _answerResponse$data3.Options) !== null && _answerResponse$data$ !== void 0 ? _answerResponse$data$ : [];
                                        var questionAnswerItem = answerResponseData.find(function (item) { return (item === null || item === void 0 ? void 0 : item.QuestionId) === (questionItem === null || questionItem === void 0 ? void 0 : questionItem.QuestionId); });
                                        return ["Battery No. ".concat(index + 1), (_questionAnswerItem$R = questionAnswerItem === null || questionAnswerItem === void 0 ? void 0 : questionAnswerItem.ResponseValue) !== null && _questionAnswerItem$R !== void 0 ? _questionAnswerItem$R : ''];
                                    })
                                });
                            }
                            return null;
                        }).filter(function (item) { return item !== null; });
                        setBatteryDynamicList(result_1);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getFuelLevel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _data$ProductId, productAttributeBody, productAttributeResult, fuelAttributeValue, requestBody, QuestionsResponse, QuestionsList, questionsAnswers_1, result_2, fuelGroup;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!data) return [3 /*break*/, 4];
                    productAttributeBody = {
                        "ProductId": (_data$ProductId = data === null || data === void 0 ? void 0 : data.ProductId) !== null && _data$ProductId !== void 0 ? _data$ProductId : ''
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: productAttributeValueUrl,
                            request: productAttributeBody
                        }))];
                case 1:
                    productAttributeResult = _a.sent();
                    if (!(productAttributeResult.payload.value.success && productAttributeResult.payload.value.data)) return [3 /*break*/, 4];
                    fuelAttributeValue = productAttributeResult.payload.value.data.Value;
                    if (!fuelAttributeValue) return [3 /*break*/, 4];
                    requestBody = {
                        "SystemName": "FuelUsed-".concat(fuelAttributeValue),
                        "ProductId": data !== null && data !== void 0 && data.ProductId ? data === null || data === void 0 ? void 0 : data.ProductId : data !== null && data !== void 0 && data.ProductId ? data === null || data === void 0 ? void 0 : data.ProductId : "",
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: requestBody
                        }))];
                case 2:
                    QuestionsResponse = _a.sent();
                    if (!QuestionsResponse.payload.value.success) return [3 /*break*/, 4];
                    QuestionsList = QuestionsResponse.payload.value.data;
                    return [4 /*yield*/, getPrecheckAnswersByModelId()];
                case 3:
                    questionsAnswers_1 = _a.sent();
                    result_2 = QuestionsList === null || QuestionsList === void 0 ? void 0 : QuestionsList.map(function (questionGroupItem) {
                        if (questionGroupItem.Questions && questionGroupItem.Questions.length > 0) {
                            var SortedQuestionsBySequence = __spreadArray([], questionGroupItem.Questions, true).sort(function (a, b) { return a.Sequence - b.Sequence; });
                            return _objectSpread(_objectSpread({}, questionGroupItem), {}, {
                                Questions: SortedQuestionsBySequence === null || SortedQuestionsBySequence === void 0 ? void 0 : SortedQuestionsBySequence.map(function (questionItem) {
                                    var questionAnswerItem = questionsAnswers_1 === null || questionsAnswers_1 === void 0 ? void 0 : questionsAnswers_1.find(function (item) { return item.QuestionId === questionItem.QuestionId; });
                                    return _objectSpread(_objectSpread({}, questionItem), {}, {
                                        ResponseValue: questionAnswerItem && questionAnswerItem.ResponseValue ? questionAnswerItem.ResponseValue : ''
                                    });
                                })
                            });
                        }
                    });
                    setFuelIndicatorDynamicList(result_2);
                    fuelGroup = result_2 === null || result_2 === void 0 ? void 0 : result_2.find(function (group) { return group.QuestionGroupName === "FuelIndicator"; });
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var handleKeyPress = function (event) {
            if (event.ctrlKey && event.key === "d") {
                event.preventDefault();
                generatePDF();
            }
        };
        document.addEventListener("keydown", handleKeyPress);
        return function () {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, []);
    function truncateTextToBox(doc, text, boxWidth, boxHeight, options) {
        var _doc$getFontSize, _doc$getFont, _doc$getFont2;
        if (!text)
            return '';
        var fontSize = (options === null || options === void 0 ? void 0 : options.fontSize) || ((_doc$getFontSize = doc.getFontSize) === null || _doc$getFontSize === void 0 ? void 0 : _doc$getFontSize.call(doc)) || 10;
        var fontName = (options === null || options === void 0 ? void 0 : options.fontName) || ((_doc$getFont = doc.getFont) === null || _doc$getFont === void 0 || (_doc$getFont = _doc$getFont.call(doc)) === null || _doc$getFont === void 0 ? void 0 : _doc$getFont.fontName) || "helvetica";
        var fontStyle = (options === null || options === void 0 ? void 0 : options.fontStyle) || ((_doc$getFont2 = doc.getFont) === null || _doc$getFont2 === void 0 || (_doc$getFont2 = _doc$getFont2.call(doc)) === null || _doc$getFont2 === void 0 ? void 0 : _doc$getFont2.fontStyle) || "normal";
        var lineHeight = (options === null || options === void 0 ? void 0 : options.lineHeight) || 4; // mm per line
        if (doc.setFont)
            doc.setFont(fontName, fontStyle);
        if (doc.setFontSize)
            doc.setFontSize(fontSize);
        var lines = doc.splitTextToSize(text, boxWidth);
        var maxLines = Math.floor(boxHeight / lineHeight);
        if (lines.length <= maxLines) {
            return lines.join('\n');
        }
        else {
            var truncatedLines = lines.slice(0, maxLines);
            var lastLine = truncatedLines[truncatedLines.length - 1];
            var ellipsis = "...";
            var availableWidth = boxWidth - doc.getTextWidth(ellipsis);
            var truncatedLastLine = lastLine;
            while (doc.getTextWidth(truncatedLastLine) > availableWidth && truncatedLastLine.length > 0) {
                truncatedLastLine = truncatedLastLine.slice(0, -1);
            }
            truncatedLines[truncatedLines.length - 1] = truncatedLastLine + ellipsis;
            return truncatedLines.join('\n');
        }
    }
    var jobCardServiceGroupMap = {
        1: 'Additional Jobs',
        2: 'Standard Jobs',
        3: 'PMS',
        4: 'Declined Jobs'
    };
    var sourcePriority = {
        "PMS": 1,
        "Standard Jobs": 2,
        "Additional Jobs": 3,
        "Decline Jobs": 4
    };
    function sortBySourcePriority() {
        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var sourceKey = arguments.length > 1 ? arguments[1] : undefined;
        var sourcePriority = arguments.length > 2 ? arguments[2] : undefined;
        return __spreadArray([], items, true).sort(function (a, b) {
            var priorityA = sourcePriority[a[sourceKey]] || 0;
            var priorityB = sourcePriority[b[sourceKey]] || 0;
            return priorityA - priorityB;
        });
    }
    function formatDetails(data, sourceKey, sourceName) {
        var rawDetails = (data || []).map(function (item) {
            var _a;
            return (_a = {},
                _a["".concat(sourceName + 'Code')] = (item === null || item === void 0 ? void 0 : item.ChildCode) || '',
                _a["".concat(sourceName + 'Source')] = jobCardServiceGroupMap[item === null || item === void 0 ? void 0 : item.JobCardServiceGroup] || '',
                _a["".concat(sourceName + 'Name')] = item !== null && item !== void 0 && item.ChildName ? "".concat(item === null || item === void 0 ? void 0 : item.ChildName, "-(").concat(item === null || item === void 0 ? void 0 : item.ChildCode, ")") : '',
                _a["".concat(sourceName + 'Quantity')] = (item === null || item === void 0 ? void 0 : item.Quantity.toFixed(2)) || 0.00,
                _a["".concat(sourceName + 'Amount')] = item !== null && item !== void 0 && item.Amount ? parseFloat(item === null || item === void 0 ? void 0 : item.Amount).toFixed(2) : 0.00,
                _a);
        });
        var sortedParts = sortBySourcePriority(rawDetails, sourceKey, sourcePriority);
        return sortedParts.map(function (item, index) { return _objectSpread({
            srNo: index + 1
        }, item); });
    }
    var formattedPartDetails = formatDetails(data === null || data === void 0 ? void 0 : data.partDetails, SourceItem_E.partSource, 'part');
    var formattedLabourDetails = formatDetails(data === null || data === void 0 ? void 0 : data.labourDetails, SourceItem_E.labourSource, 'labour');
    function wrapText(text, maxLength) {
        var cleanText = (text || '').trim();
        var result = [];
        var i = 0;
        while (i < cleanText.length) {
            result.push(cleanText.slice(i, i + maxLength));
            i += maxLength;
        }
        return result;
    }
    var generatePDF = function () {
        var arguments_1 = arguments;
        return __awaiter(this, void 0, void 0, function () {
            var _data$ServiceAdvisorN, _data$TechnicianName, _data$FloorSupervisor, mode, doc, observationOnNextPage, isCustomerVoiceOnNextPage, pageHeight, headerHeight, footerHeight, pageWidth, renderDetails, divider2Y, addHeader, addOtherPagesHeader, addFooter, addOtherPageFooter, renderTable, drawVehicleInspectionSection, inspectionStartX, pageNumber, customerComplaintStart, _installbaseDetailsBy21, _installbaseDetailsBy22, _organizationAddress3, _customer$PrimaryCont5, _customer$PrimaryCont6, _installbaseDetailsBy23, _installbaseDetailsBy24, _installbaseDetailsBy25, _installbaseDetailsBy26, _installbaseDetailsBy27, _installbaseDetailsBy28, _installbaseDetailsBy29, _data$SourceDocumentN3, _data$RepairTypeName2, _dayjs$format2, _data$ODOMeterReading2, _data$CustomerVoice2, lineHeightCust, pageWidth_1, startY, lineHeight, logoWidth_1, logoHeight_1, logoX_1, logoY_1, regBoxPaddingX, regText, labelWidth, boxWidth, boxheight, boxX, boxY, baseY, leftX, leftY, orgNameLines, orgNameY, addressStartY, columnCount, sectionWidth, customerX, startX_1, currentY_1, labelWidthCustomer_1, valueWidthCustomer_1, lineSpacingCustomer_1, details, finalCustomerDetailsY, vehicleX, vehicleY, jobCardX, jobCardY, serviceX, dividerX, dividerY, LastY, inspectionStartY, dividerEndY, dividerXForLine, revisitedX, revisitedY, CampaignX, CampaignY, NPSX, NPSY, customerComplaint, lines, complaintHeight, customerComplaintEndY, thresholdHeight, afterCustomerVoiceY, customerVoiceEndPage, alocationDetailsY, availableHeight, startingPageVisitVisitedDetails, last2VisitsTableY, EstimationDetails, estimateTableY, allocationStartY, allocationDetails, afterLabourTableY, currentPage, remainingHeight, estimatedTableHeight, startingPage, sectionWidth, observationY, observationBoxHeight, startX, customerVoiceHeight, partTableY, startingPageAfterPartTable, labourTableY, startingPageAfterLabourTable, declarationHeight, declarationY, marginL, declarationHeightY, declaration, signatureY, serviceAdvisorX, customerLineStartX, customerLineEndX, logoWidth, logoHeight, lineCenterX, logoX, logoY, advisorLineWidth, advisorLineEndX, advisorLineStartX, isMobile_1, pdfBlob, blobUrl, newWindow, iframe_1;
            return __generator(this, function (_a) {
                mode = arguments_1.length > 0 && arguments_1[0] !== undefined ? arguments_1[0] : 'download';
                doc = new jsPDF({
                    orientation: "landscape",
                    unit: "mm",
                    format: "a4"
                });
                observationOnNextPage = false;
                isCustomerVoiceOnNextPage = false;
                pageHeight = doc.internal.pageSize.height;
                headerHeight = 54;
                footerHeight = 50;
                pageWidth = doc.internal.pageSize.getWidth();
                renderDetails = function (title, details, startX, startY) {
                    var valueOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;
                    var keyWidth = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 20;
                    var valueWidth = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 30;
                    var lineHeight = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 4;
                    var currentY = startY + 2;
                    doc.setFontSize(8);
                    doc.setFont("helvetica", "bold");
                    doc.text(title || '', startX, startY + 1);
                    if (Array.isArray(details)) {
                        details === null || details === void 0 || details.forEach(function (_ref4) {
                            var label = _ref4[0], value = _ref4[1];
                            currentY += lineHeight;
                            doc.setFontSize(7);
                            doc.setFont("helvetica", "bold");
                            doc.text(label || '', startX, currentY, {
                                maxWidth: keyWidth
                            });
                            doc.setFontSize(7);
                            doc.setFont("helvetica", "normal");
                            // const wrappedText = doc.splitTextToSize(value, valueWidth);
                            // doc.text(": " + value, startX + valueOffset, currentY, { maxWidth: valueWidth });
                            // currentY += (wrappedText.length - 1) * lineHeight;
                            var wrappedText = doc.splitTextToSize(value, valueWidth);
                            // doc.text(": " + value, startX + valueOffset, currentY, { maxWidth: valueWidth });
                            // currentY += (wrappedText.length - 1) * lineHeight;
                            doc.text(": ".concat(wrappedText[0]), startX + valueOffset, currentY);
                            // Calculate width of ": " to use as left padding on next lines
                            var colonWidth = doc.getTextWidth(": ");
                            // Draw remaining lines with left padding to align properly
                            for (var i = 1; i < wrappedText.length; i++) {
                                currentY += 3;
                                doc.text(" ".repeat(1), startX + valueOffset, currentY); // Optional spacing, not strictly needed
                                doc.text(wrappedText[i] || '', startX + valueOffset + colonWidth, currentY);
                            }
                        });
                    }
                    return currentY;
                };
                divider2Y = 0;
                addHeader = function (doc) {
                    var _installbaseDetailsBy2, _installbaseDetailsBy3, _organizationAddress, _customer$PrimaryCont, _customer$PrimaryCont2, _installbaseDetailsBy4, _installbaseDetailsBy5, _installbaseDetailsBy6, _installbaseDetailsBy7, _installbaseDetailsBy8, _installbaseDetailsBy9, _installbaseDetailsBy10, _data$SourceDocumentN, _data$RepairTypeName, _dayjs$format, _data$ODOMeterReading, _data$CustomerVoice;
                    var pageWidth = doc.internal.pageSize.getWidth();
                    var startY = 5;
                    var lineHeight = 4;
                    var logoWidth = (SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) === 'Triumph' ? 20 : 15;
                    var logoHeight = 7;
                    var logoX = 10;
                    var logoY = startY;
                    doc.addImage(logoBase64, "PNG", logoX, logoY, logoWidth, logoHeight);
                    doc.setFontSize(12);
                    doc.setFont("helvetica", "bold");
                    doc.text("JOB CARD", pageWidth / 2, logoY + logoHeight / 2, {
                        align: "center"
                    });
                    //registartion no box
                    var regBoxPaddingX = 4;
                    var regText = "Registration No.";
                    doc.setFontSize(7);
                    var labelWidth = doc.getTextWidth(regText + '  : ');
                    var boxWidth = 45;
                    var boxheight = 5;
                    var boxX = doc.internal.pageSize.getWidth() - boxWidth - 10;
                    var boxY = 5;
                    doc.setDrawColor(0);
                    doc.setLineWidth(0.132);
                    doc.rect(boxX, boxY, boxWidth, boxheight);
                    doc.setFontSize(7);
                    doc.text(regText + '  : ', boxX + regBoxPaddingX, boxY + 3.2);
                    doc.setFont("helvetica", "normal");
                    doc.text((_installbaseDetailsBy2 = installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy3 = installbaseDetailsById.data) === null || _installbaseDetailsBy3 === void 0 ? void 0 : _installbaseDetailsBy3.RegistrationNo) !== null && _installbaseDetailsBy2 !== void 0 ? _installbaseDetailsBy2 : '', boxX + regBoxPaddingX + labelWidth, boxY + 3.2);
                    var baseY = logoY + logoHeight + 4;
                    var leftX = 10;
                    var leftY = baseY;
                    doc.setFontSize(7);
                    doc.setFont("helvetica", "bold");
                    doc.text(selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.OrganizationName ? selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationName : '', leftX, leftY, {
                        maxWidth: 45
                    });
                    doc.setFont("helvetica", "normal");
                    doc.text((_organizationAddress = organizationAddress) !== null && _organizationAddress !== void 0 ? _organizationAddress : '', leftX, leftY + 4, {
                        maxWidth: 40
                    });
                    doc.setLineWidth(0.132);
                    var columnCount = 5;
                    var sectionWidth = pageWidth / columnCount;
                    var customerX = sectionWidth;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(7);
                    doc.text("Customer details:", customerX - 2, baseY);
                    doc.setFont("helvetica", "normal");
                    var startX = customerX - 2;
                    var currentY = baseY + 5;
                    var labelWidthCustomer = 15;
                    var valueWidthCustomer = 40;
                    var lineSpacingCustomer = 3.5;
                    var details = [["Name", truncateTextWithLines(doc, customer === null || customer === void 0 ? void 0 : customer.PersonName, valueWidthCustomer, 2)], ["Email", (customer === null || customer === void 0 || (_customer$PrimaryCont = customer.PrimaryContact) === null || _customer$PrimaryCont === void 0 ? void 0 : _customer$PrimaryCont.Email) || ''], ["Contact no.", (customer === null || customer === void 0 || (_customer$PrimaryCont2 = customer.PrimaryContact) === null || _customer$PrimaryCont2 === void 0 ? void 0 : _customer$PrimaryCont2.MobileNumber) || ''], ["Address", (function (_truncateAddress) {
                                var address = (customer === null || customer === void 0 ? void 0 : customer.Address) || '';
                                var truncated = ((_truncateAddress = truncateAddress(address, 80)) === null || _truncateAddress === void 0 ? void 0 : _truncateAddress.replace(/,(\S)/g, ', $1')) || '';
                                var tempDoc = doc; // use the same doc instance for splitTextToSize
                                var lines = tempDoc.splitTextToSize(truncated, 40);
                                if (lines.length > 3) {
                                    lines = lines.slice(0, 3);
                                    if (!lines[2].endsWith('...')) {
                                        lines[2] = lines[2].replace(/(.{0,37}).*/, '$1...'); // ensure max width
                                    }
                                }
                                return lines.join('\n');
                            })()]];
                    details === null || details === void 0 || details.forEach(function (_ref5) {
                        var label = _ref5[0], value = _ref5[1];
                        if (typeof value === 'string') {
                            value = value.trimStart();
                            if (value.startsWith('\n')) {
                                value = value.replace(/^\n+/, '');
                            }
                        }
                        doc.setFont("helvetica", "bold");
                        doc.text(label, startX, currentY, {
                            maxWidth: labelWidthCustomer
                        });
                        doc.setFont("helvetica", "normal");
                        var valueLines = [];
                        if (typeof value === 'string') {
                            valueLines = doc.splitTextToSize(": ".concat(String(value)), valueWidthCustomer);
                        }
                        else {
                            valueLines = [": ".concat(String(value))];
                        }
                        valueLines.forEach(function (line, idx) {
                            doc.text(line, startX + labelWidthCustomer, currentY + idx * (lineSpacingCustomer - 0.5), {
                                maxWidth: valueWidthCustomer
                            });
                        });
                        currentY += valueLines.length * lineSpacingCustomer;
                    });
                    var finalCustomerDetailsY = currentY;
                    // Vehicle Details
                    var vehicleX = sectionWidth * 2;
                    var vehicleY = renderDetails("Vehicle details:", [["Model", "".concat((installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy4 = installbaseDetailsById.data) === null || _installbaseDetailsBy4 === void 0 ? void 0 : _installbaseDetailsBy4.ProductName) || '', " ").concat(installbaseDetailsById !== null && installbaseDetailsById !== void 0 && (_installbaseDetailsBy5 = installbaseDetailsById.data) !== null && _installbaseDetailsBy5 !== void 0 && _installbaseDetailsBy5.ProductCode ? "(".concat(installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy6 = installbaseDetailsById.data) === null || _installbaseDetailsBy6 === void 0 ? void 0 : _installbaseDetailsBy6.ProductCode, ")") : '')], ["Reg. no.", (installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy7 = installbaseDetailsById.data) === null || _installbaseDetailsBy7 === void 0 ? void 0 : _installbaseDetailsBy7.RegistrationNo) || ''], ["Chassis no.", (installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy8 = installbaseDetailsById.data) === null || _installbaseDetailsBy8 === void 0 ? void 0 : _installbaseDetailsBy8.VinNo) || ''], ["Engine no.", (installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy9 = installbaseDetailsById.data) === null || _installbaseDetailsBy9 === void 0 ? void 0 : _installbaseDetailsBy9.EngineNo) || ''], ["Date of sale", installbaseDetailsById !== null && installbaseDetailsById !== void 0 && (_installbaseDetailsBy10 = installbaseDetailsById.data) !== null && _installbaseDetailsBy10 !== void 0 && _installbaseDetailsBy10.SalesInvoiceDate ? dateFormate(installbaseDetailsById === null || installbaseDetailsById === void 0 ? void 0 : installbaseDetailsById.data.SalesInvoiceDate) : "-"]], vehicleX - 2, baseY, 15, 20, 40);
                    // Job Card Details
                    var jobCardX = sectionWidth * 3;
                    var jobCardY = renderDetails("Job card details:", [["Job card no", (_data$SourceDocumentN = data === null || data === void 0 ? void 0 : data.SourceDocumentNo) !== null && _data$SourceDocumentN !== void 0 ? _data$SourceDocumentN : ''], ["Service type", (_data$RepairTypeName = data === null || data === void 0 ? void 0 : data.RepairTypeName) !== null && _data$RepairTypeName !== void 0 ? _data$RepairTypeName : ''], ["Total KMs Reading", TotalKMReading !== null && TotalKMReading !== void 0 ? TotalKMReading : ''], ["Expected Start Time ", ""]], jobCardX - 7, baseY, 25, 40, 30);
                    var serviceX = sectionWidth * 4;
                    renderDetails("", [["Job Card Date & Time", (_dayjs$format = dayjs(data === null || data === void 0 ? void 0 : data.JobCardDate).format("DD MMM, YYYY hh:mm A")) !== null && _dayjs$format !== void 0 ? _dayjs$format : ''], ["Current KMs Reading", (_data$ODOMeterReading = data === null || data === void 0 ? void 0 : data.ODOMeterReading) !== null && _data$ODOMeterReading !== void 0 ? _data$ODOMeterReading : ''], ["Odometer Replaced On", ''], ["Estimate Delivery Time", "".concat(dayjs(EstimateDetails === null || EstimateDetails === void 0 ? void 0 : EstimateDetails.DeliveryDate).format('DD MMM, YYYY hh:mm A'))]], serviceX - 7, baseY, 30, 40, 30);
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.132);
                    var dividerX = sectionWidth - 5;
                    var dividerY = Math.max(leftY, vehicleY, jobCardY) + lineHeight;
                    doc.line(dividerX, baseY - logoHeight + 2, dividerX, dividerY - 2);
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.264);
                    var LastY = Math.max(finalCustomerDetailsY, dividerY);
                    divider2Y = LastY;
                    doc.line(10, LastY, pageWidth - 10, LastY);
                    var inspectionStartY = headerHeight - 1;
                    var dividerEndY = pageHeight - footerHeight - 1;
                    var dividerXForLine = 190;
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.132);
                    doc.line(dividerXForLine, divider2Y ? divider2Y : LastY, dividerXForLine, dividerEndY);
                    drawVehicleInspectionSection(doc, inspectionStartX, LastY + 4);
                    var revisitedX = 10;
                    var revisitedY = renderDetails("Other details:", [["Revisited", isRevisited ? 'Yes' : 'No'], ["Last NPS Feedback", category !== null && category !== void 0 ? category : ''], ["Hex File Update", ""], ["Open Complaint", ""]], revisitedX, LastY + 4, 30, 40, 15);
                    var CampaignX = sectionWidth - 5;
                    var CampaignY = renderDetails("", [["No. of Complaints In Last 6 Months", ''], ["Campaign ", (data === null || data === void 0 ? void 0 : data.CampaignName) || ''], ["Lost customer", ""]], CampaignX + 3, LastY + 4, 42, 42, 25);
                    var NPSX = sectionWidth * 2;
                    var NPSY = renderDetails("", [["AMC Expiry Date", ""], ["EW / ATW Expiry Date", ""], ["RSA Expiry Date", ""]], NPSX + 10, LastY + 4, 30, 30);
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.132);
                    divider2Y = Math.max(leftY, revisitedY, CampaignY, NPSY, LastY + 4);
                    doc.line(10, divider2Y + 3, 187, divider2Y + 3);
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(8);
                    doc.text("Customer voice:", 10, divider2Y + 8);
                    doc.setFont("helvetica", "normal");
                    var customerComplaint = ((data === null || data === void 0 || (_data$CustomerVoice = data.CustomerVoice) === null || _data$CustomerVoice === void 0 || (_data$CustomerVoice = _data$CustomerVoice[0]) === null || _data$CustomerVoice === void 0 ? void 0 : _data$CustomerVoice.CustomerComplaint) || '').replace(/\s+/g, ' ') || "";
                    var complaintText = truncateTextWithLines(doc, customerComplaint, 150, 3) || '';
                    doc.text(complaintText, 35, divider2Y + 8, {
                        maxWidth: 150
                    });
                    return divider2Y + 8;
                };
                addOtherPagesHeader = function (doc) {
                    var _installbaseDetailsBy11, _installbaseDetailsBy12;
                    var pageWidth = doc.internal.pageSize.getWidth();
                    var startY = 10;
                    doc.setFontSize(12);
                    doc.setFont("helvetica", "bold");
                    doc.text("JOB CARD", pageWidth / 2, startY, {
                        align: "center"
                    });
                    var baseY = 15;
                    var regBoxPaddingX = 4;
                    var regText = "Registration No.";
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(7);
                    var labelWidth = doc.getTextWidth(regText + '  : ');
                    var boxWidth = 45;
                    var boxheight = 5;
                    var boxX = doc.internal.pageSize.getWidth() - boxWidth - 10;
                    var boxY = 5;
                    doc.setDrawColor(0);
                    doc.setLineWidth(0.132);
                    doc.rect(boxX, boxY, boxWidth, boxheight);
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(7);
                    doc.text(regText + '  : ', boxX + regBoxPaddingX, boxY + 3.2);
                    doc.setFont("helvetica", "normal");
                    doc.text((_installbaseDetailsBy11 = installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy12 = installbaseDetailsById.data) === null || _installbaseDetailsBy12 === void 0 ? void 0 : _installbaseDetailsBy12.RegistrationNo) !== null && _installbaseDetailsBy11 !== void 0 ? _installbaseDetailsBy11 : '', boxX + regBoxPaddingX + labelWidth, boxY + 3.2);
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.264);
                    doc.line(10, baseY + 1, pageWidth - 10, baseY + 1);
                };
                addFooter = function (totalPages) {
                    var _installbaseDetailsBy13, _installbaseDetailsBy14, _installbaseDetailsBy15, _installbaseDetailsBy16, _installbaseDetailsBy17, _installbaseDetailsBy18, _installbaseDetailsBy19, _installbaseDetailsBy20, _customer$PersonName, _customer$PrimaryCont3, _customer$PrimaryCont4, _data$SourceDocumentN2, _getContactDetailsDat, _data$JobCardInsuranc, _data$JobCardInsuranc2, _data$JobCardInsuranc3, _data$JobCardInsuranc4, _organizationAddress2;
                    var marginLeft = 10;
                    var pageWidth = 297;
                    var usableWidth = pageWidth - marginLeft * 2;
                    var sectionWidth = usableWidth / 4;
                    var startY = pageHeight - footerHeight + 15;
                    var lineY = pageHeight - footerHeight + 85;
                    doc.setFontSize(8);
                    doc.setFont("helvetica", "normal");
                    var centerDividerX = marginLeft + sectionWidth * 2;
                    var dividerTopY = startY - 5;
                    var dividerBottomY = lineY - 40;
                    var lineStartX = marginLeft + 8;
                    var lineEndX = pageWidth - marginLeft - 6;
                    doc.setDrawColor(0);
                    doc.setLineWidth(0.2);
                    doc.setLineDashPattern([1, 1], 0);
                    var dashedLineStartX = marginLeft + 2;
                    var dashedLineEndX = pageWidth - marginLeft;
                    var dashedLineY = startY - 14;
                    doc.line(dashedLineStartX, dashedLineY, dashedLineEndX, dashedLineY);
                    doc.setLineDashPattern([], 0);
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(10);
                    var scissorSize = 4;
                    var scissorY = startY - 16;
                    var scissorLeftX = lineStartX - scissorSize - 6;
                    var scissorRightX = lineEndX + 5;
                    doc.addImage(scissorImageBase64, 'PNG', scissorLeftX, scissorY, scissorSize, scissorSize);
                    doc.addImage(scissorRightImageBase64, 'PNG', scissorRightX, scissorY, scissorSize, scissorSize);
                    doc.setFontSize(8);
                    doc.text("Vehicle Acknowledgement", pageWidth / 2, scissorY + 7, {
                        align: 'center'
                    });
                    doc.setDrawColor(0);
                    doc.setLineWidth(0.264);
                    doc.line(centerDividerX, dividerTopY, centerDividerX, dividerBottomY);
                    // --- Left Section ---
                    // renderDetails("", [
                    //     // ["Job card no", data?.SourceDocumentNo ?? ''],
                    //     ["Reg no", installbaseDetailsById?.data?.RegistrationNo ?? ''],
                    //     ["Chassis no", installbaseDetailsById?.data?.VinNo ?? ''],
                    //     ["Model", `${installbaseDetailsById?.data?.ProductName ?? ''} ${installbaseDetailsById?.data?.ProductCode ? `(${installbaseDetailsById?.data?.ProductCode})` : ''}`],
                    //     ["Customer name", customer?.PersonName ?? ''],
                    //     ["Phone no", customer?.PrimaryContact?.MobileNumber ?? '']
                    // ], marginLeft, startY - 7, 20, 20, 45);
                    renderDetails("", [
                        // ["Job card no", data?.SourceDocumentNo ?? ''],
                        ["Model Name", "".concat((_installbaseDetailsBy13 = installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy14 = installbaseDetailsById.data) === null || _installbaseDetailsBy14 === void 0 ? void 0 : _installbaseDetailsBy14.ProductName) !== null && _installbaseDetailsBy13 !== void 0 ? _installbaseDetailsBy13 : '', " ").concat(installbaseDetailsById !== null && installbaseDetailsById !== void 0 && (_installbaseDetailsBy15 = installbaseDetailsById.data) !== null && _installbaseDetailsBy15 !== void 0 && _installbaseDetailsBy15.ProductCode ? "(".concat(installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy16 = installbaseDetailsById.data) === null || _installbaseDetailsBy16 === void 0 ? void 0 : _installbaseDetailsBy16.ProductCode, ")") : '')], ["Reg No.", (_installbaseDetailsBy17 = installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy18 = installbaseDetailsById.data) === null || _installbaseDetailsBy18 === void 0 ? void 0 : _installbaseDetailsBy18.RegistrationNo) !== null && _installbaseDetailsBy17 !== void 0 ? _installbaseDetailsBy17 : ''], ["Chassis No.", (_installbaseDetailsBy19 = installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy20 = installbaseDetailsById.data) === null || _installbaseDetailsBy20 === void 0 ? void 0 : _installbaseDetailsBy20.VinNo) !== null && _installbaseDetailsBy19 !== void 0 ? _installbaseDetailsBy19 : ''], ["Customer Name", (_customer$PersonName = customer === null || customer === void 0 ? void 0 : customer.PersonName) !== null && _customer$PersonName !== void 0 ? _customer$PersonName : ''], ["Contact No.", (_customer$PrimaryCont3 = customer === null || customer === void 0 || (_customer$PrimaryCont4 = customer.PrimaryContact) === null || _customer$PrimaryCont4 === void 0 ? void 0 : _customer$PrimaryCont4.MobileNumber) !== null && _customer$PrimaryCont3 !== void 0 ? _customer$PrimaryCont3 : '']
                    ], marginLeft, startY - 7, 20, 20, 45);
                    // --- Signature Section ---
                    var lineYY = startY + 43;
                    doc.setFont("helvetica", "normal");
                    doc.text("Service Advisor Signature", marginLeft, lineYY - 15);
                    doc.line(marginLeft + 30, lineYY - 15, marginLeft + 60, lineYY - 15); // Signature line
                    // --- Center Section ---
                    renderDetails("", [["Job Card No.", (_data$SourceDocumentN2 = data === null || data === void 0 ? void 0 : data.SourceDocumentNo) !== null && _data$SourceDocumentN2 !== void 0 ? _data$SourceDocumentN2 : ''], ["Job Card Date & Time", dayjs(data === null || data === void 0 ? void 0 : data.JobCardDate).format("DD MMM, YYYY hh:mm A")], ["Estimated Total Amt.", GrandTotal],
                        // ["Estimated delivery date", `${dayjs(EstimateDetails?.DeliveryDate).format('DD MMM, YYYY')}`],
                        ["Estimate Delivery Time", "".concat(dayjs(EstimateDetails === null || EstimateDetails === void 0 ? void 0 : EstimateDetails.DeliveryDate).format('DD MMM, YYYY hh:mm A'))], ["SA Name", truncateAddress(data === null || data === void 0 ? void 0 : data.ServiceAdvisorName, 16) || ''], ["SA Contact No.", getContactDetailsData === null || getContactDetailsData === void 0 || (_getContactDetailsDat = getContactDetailsData.data) === null || _getContactDetailsDat === void 0 ? void 0 : _getContactDetailsDat.MobileNumber], ["Insurance Policy No.", (_data$JobCardInsuranc = data === null || data === void 0 || (_data$JobCardInsuranc2 = data.JobCardInsuranceDetail) === null || _data$JobCardInsuranc2 === void 0 ? void 0 : _data$JobCardInsuranc2.PolicyNumber) !== null && _data$JobCardInsuranc !== void 0 ? _data$JobCardInsuranc : ''], ["Policy Valid Till", data !== null && data !== void 0 && (_data$JobCardInsuranc3 = data.JobCardInsuranceDetail) !== null && _data$JobCardInsuranc3 !== void 0 && _data$JobCardInsuranc3.PolicyExpiryDate ? dayjs(data === null || data === void 0 || (_data$JobCardInsuranc4 = data.JobCardInsuranceDetail) === null || _data$JobCardInsuranc4 === void 0 ? void 0 : _data$JobCardInsuranc4.PolicyExpiryDate).format("DD MMM, YYYY") : '']], marginLeft + sectionWidth + 5, startY - 8, 30, 30, 30);
                    // --- Right Section (Dealer Info) ---
                    var rightX = marginLeft + sectionWidth * 2;
                    doc.setFont("helvetica", "bold");
                    // doc.text(selectedBranch?.OrganizationName ?? '', rightX + 5, startY - 3);
                    var orgNameLines1 = doc.splitTextToSize((selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationName) || '', 50);
                    var orgNameY1 = startY - 3;
                    doc.text(orgNameLines1, rightX + 5, startY - 3);
                    doc.setFont("helvetica", "normal");
                    var addressStartY1 = orgNameY1 + orgNameLines1.length * 3;
                    doc.setFont("helvetica", "normal");
                    doc.text((_organizationAddress2 = organizationAddress) !== null && _organizationAddress2 !== void 0 ? _organizationAddress2 : '', rightX + 5, addressStartY1 + 1, {
                        maxWidth: 50
                    });
                    var businessHours = "".concat(startFormatted, " to ").concat(endFormatted);
                    doc.text("Working Hours: ".concat(businessHours, "                  Lunch Timing:              Weekly Off:        "), pageWidth / 2 + 5, startY + 30);
                    var termsX = marginLeft + sectionWidth * 3;
                    doc.setFont("helvetica", "bold");
                    doc.text("Terms & Conditions:", termsX - 7, startY - 3);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(6);
                    var shortTerms = ["1. Please remove all valuables.", "2. Vehicle kept , stored in workshop & driven by staff at Owner's risk.", "3. Taxes extra as applicable.", "4. Any additional repair done outside will be charged extra.", "5. All disputes are subject to jurisdiction of local court, where service & repair work is performed."];
                    if (Array.isArray(shortTerms)) {
                        shortTerms === null || shortTerms === void 0 || shortTerms.forEach(function (line, i) {
                            doc.text(line, termsX - 7, startY + 1 + i * 4, {
                                maxWidth: 80
                            });
                        });
                    }
                    doc.setFont("italic");
                    doc.text("Working hours: 10 AM to 8 PM", marginLeft, lineY);
                    doc.text("Lunch timing: 1 PM - 2 PM", marginLeft + sectionWidth, lineY);
                    doc.text("Weekly off: Sat & Sun", marginLeft + sectionWidth * 2, lineY);
                    doc.setFont("normal");
                    doc.setFontSize(8);
                    doc.line(14, lineY + 5, 283, lineY + 5);
                };
                addOtherPageFooter = function (doc) {
                    var totalPagesFinal = doc.internal.getNumberOfPages();
                    var marginLeft = 10;
                    var pageWidth = 297;
                    var startY = pageHeight - footerHeight + 15;
                    var lineStartX = marginLeft + 8;
                    var lineEndX = pageWidth - marginLeft - 6;
                    doc.setDrawColor(0);
                    doc.setLineWidth(0.2);
                    doc.setLineDashPattern([1, 1], 0);
                    var dashedLineStartX = marginLeft + 2;
                    var dashedLineEndX = pageWidth - marginLeft;
                    var dashedLineY = startY - 14;
                    doc.line(dashedLineStartX, dashedLineY, dashedLineEndX, dashedLineY);
                    doc.setLineDashPattern([], 0);
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(10);
                    var scissorSize = 5;
                    var scissorY = startY - 16;
                    var scissorLeftX = lineStartX - scissorSize - 5;
                    var scissorRightX = lineEndX + 5;
                    doc.addImage(scissorImageBase64, 'PNG', scissorLeftX, scissorY, scissorSize, scissorSize);
                    doc.addImage(scissorRightImageBase64, 'PNG', scissorRightX, scissorY, scissorSize, scissorSize);
                    doc.setFontSize(8);
                };
                renderTable = function (_ref6) {
                    var _a;
                    var _ref7;
                    var title = _ref6.title, data = _ref6.data, columns = _ref6.columns, startY = _ref6.startY, _b = _ref6.customColumnWidths, customColumnWidths = _b === void 0 ? {} : _b, tableWidth = _ref6.tableWidth, _c = _ref6.marginLeft, marginLeft = _c === void 0 ? 10 : _c, _d = _ref6.isDoubleTable, isDoubleTable = _d === void 0 ? false : _d, emptyColumnIndex = _ref6.emptyColumnIndex, 
                    // marginTop = headerHeight,
                    _e = _ref6.marginTop, 
                    // marginTop = headerHeight,
                    marginTop = _e === void 0 ? 20 : _e, _f = _ref6.marginBottom, marginBottom = _f === void 0 ? footerHeight : _f, _g = _ref6.isHideTotalRow, isHideTotalRow = _g === void 0 ? false : _g, _h = _ref6.marginRight, marginRight = _h === void 0 ? 10 : _h;
                    var formattedData = data === null || data === void 0 ? void 0 : data.map(function (row, index) { return _objectSpread({
                        srNo: index + 1
                    }, row); });
                    var totalRow = columns === null || columns === void 0 ? void 0 : columns.reduce(function (totals, col) {
                        if (['partQuantity', 'labourQuantity', 'partAmount', 'labourAmount', 'PartPrice', 'LabourPrice', 'TotalPrice'].includes(col.field)) {
                            totals[col.field] = data === null || data === void 0 ? void 0 : data.reduce(function (sum, row) {
                                var value = parseFloat(row[col.field]);
                                return sum + (isNaN(value) ? 0 : value);
                            }, 0).toFixed(2);
                        }
                        else if (col.field === '') {
                            totals[col.field] = '';
                        }
                        else if (col.field === 'srNo') {
                            totals[col.field] = 'Total';
                        }
                        else {
                            totals[col.field] = '';
                        }
                        return totals;
                    }, {});
                    formattedData === null || formattedData === void 0 || formattedData.push(_objectSpread({
                        srNo: 'Total'
                    }, totalRow));
                    doc.setFontSize(8);
                    doc.setFont("helvetica", "bold");
                    doc.text(title || '', marginLeft, doc.internal.getNumberOfPages() === 1 ? startY : startY + 7);
                    var totalPagesFinal = 0;
                    var head = [columns === null || columns === void 0 ? void 0 : columns.map(function (col) {
                            var centerHeaders = ['S. No.', 'KMs', 'Qty', 'Amt.', 'Amount', 'labourQuantity', 'labourAmount', 'Units', 'Total Amt.', 'Total Labour Amt.', 'Total Part Amt.', 'Total Amt.', 'Est. Lab Amt.', 'Est. Part Amt.'];
                            var shouldCenter = (centerHeaders === null || centerHeaders === void 0 ? void 0 : centerHeaders.includes(col === null || col === void 0 ? void 0 : col.header)) || (centerHeaders === null || centerHeaders === void 0 ? void 0 : centerHeaders.includes(col === null || col === void 0 ? void 0 : col.field));
                            return {
                                content: col.header,
                                styles: {
                                    halign: shouldCenter ? 'center' : 'left',
                                    fontStyle: 'bold'
                                }
                            };
                        })];
                    ;
                    autoTable(doc, {
                        // head: [columns?.map(col => col?.header)],
                        head: head,
                        body: (_ref7 = isHideTotalRow ? data : formattedData) === null || _ref7 === void 0 ? void 0 : _ref7.map(function (row) { return columns === null || columns === void 0 ? void 0 : columns.map(function (col) { return row[col === null || col === void 0 ? void 0 : col.field]; }); }),
                        startY: doc.internal.getNumberOfPages() === 1 ? startY + 3 : startY + 10,
                        margin: {
                            top: marginTop,
                            bottom: marginBottom,
                            left: marginLeft,
                            right: marginRight
                        },
                        styles: {
                            fontSize: 7,
                            cellPadding: 1,
                            lineColor: [0, 0, 0],
                            overflow: 'linebreak',
                            lineWidth: 0.2
                        },
                        headStyles: {
                            fillColor: false,
                            textColor: 0,
                            fontSize: 7,
                            fontStyle: "bold"
                        },
                        bodyStyles: {
                            textColor: 0
                        },
                        columnStyles: _objectSpread(_objectSpread({}, customColumnWidths || {}), emptyColumnIndex !== undefined ? (_a = {},
                            _a[emptyColumnIndex] = {
                                cellWidth: 2,
                                lineWidth: {
                                    top: 0,
                                    bottom: 0
                                }
                            },
                            _a) : {}),
                        theme: "grid",
                        tableWidth: tableWidth,
                        didDrawPage: function (data) {
                            var doc = data.doc;
                            var pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
                            totalPagesFinal = doc.internal.getNumberOfPages();
                            var table = data.table;
                            if (pageNumber === 1) {
                                addFooter(doc);
                            }
                            else {
                                addOtherPagesHeader(doc);
                                addOtherPageFooter(doc);
                            }
                            table.settings.margin.right = 10;
                            table.settings.tableWidth = pageWidth - 20;
                        },
                        didParseCell: function (data) {
                            if (data.row && data.row.section === 'body' && data.row.raw && data.row.raw[0] === 'Total') {
                                var _data$column, _data$row;
                                data.cell.styles.fontStyle = 'bold';
                                if ((data === null || data === void 0 || (_data$column = data.column) === null || _data$column === void 0 ? void 0 : _data$column.index) === 1 && (data === null || data === void 0 || (_data$row = data.row) === null || _data$row === void 0 ? void 0 : _data$row.raw[0]) === 'Total') {
                                    var _data$row2;
                                    var startIndex = (data === null || data === void 0 || (_data$row2 = data.row) === null || _data$row2 === void 0 || (_data$row2 = _data$row2.raw) === null || _data$row2 === void 0 ? void 0 : _data$row2.indexOf("Total")) + 1;
                                    var count = 0;
                                    for (var i = startIndex; i < (data === null || data === void 0 || (_data$row3 = data.row) === null || _data$row3 === void 0 || (_data$row3 = _data$row3.raw) === null || _data$row3 === void 0 ? void 0 : _data$row3.length); i++) {
                                        var _data$row3, _data$row4;
                                        if ((data === null || data === void 0 || (_data$row4 = data.row) === null || _data$row4 === void 0 ? void 0 : _data$row4.raw[i]) === "") {
                                            count++;
                                        }
                                        else {
                                            break;
                                        }
                                    }
                                    data.cell.colSpan = count;
                                }
                            }
                            if (isDoubleTable) {
                                if ((data.section === 'body' || data.section === 'head') && data.column.index === 5) {
                                    data.cell.styles.lineWidth = {
                                        top: 0,
                                        bottom: 0,
                                        left: 0.26,
                                        right: 0
                                    };
                                }
                                if (data.section === 'body' && data.column.index === 4) {
                                    data.cell.styles.lineWidth = 0.2;
                                    data.cell.styles.lineColor = [0, 0, 0];
                                }
                            }
                        }
                    });
                };
                drawVehicleInspectionSection = function (doc, startX, startY) {
                    var _Object$entries, _inspectionRows$0$, _inspectionRows$, _inspectionRows$1$, _inspectionRows$2, _BatteryDynamicList$, _BatteryDynamicList$2, _BatteryDynamicList$3, _BatteryDynamicList$4;
                    doc.setFontSize(8);
                    doc.setFont("helvetica", "bold");
                    doc.text('Vehicle Inspection:', startX - 2, startY + 1);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(7);
                    var inspectionRows = (_Object$entries = Object.entries(fuelResponses)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.map(function (_ref8) {
                        var key = _ref8[0], value = _ref8[1];
                        return [key.trim(), value ? "".concat(value, " %") : ''];
                    });
                    var inspectionValueFirst = (_inspectionRows$0$ = inspectionRows === null || inspectionRows === void 0 || (_inspectionRows$ = inspectionRows[0]) === null || _inspectionRows$ === void 0 ? void 0 : _inspectionRows$[0]) !== null && _inspectionRows$0$ !== void 0 ? _inspectionRows$0$ : "";
                    var inspectionValueSecond = (_inspectionRows$1$ = inspectionRows === null || inspectionRows === void 0 || (_inspectionRows$2 = inspectionRows[1]) === null || _inspectionRows$2 === void 0 ? void 0 : _inspectionRows$2[0]) !== null && _inspectionRows$1$ !== void 0 ? _inspectionRows$1$ : "";
                    var maxLength = Math.max((inspectionValueFirst === null || inspectionValueFirst === void 0 ? void 0 : inspectionValueFirst.length) || 0, (inspectionValueSecond === null || inspectionValueSecond === void 0 ? void 0 : inspectionValueSecond.length) || 0);
                    var VehicleInspection = renderDetails("", inspectionRows, startX - 2, startY, maxLength + 8, maxLength + 20, 30);
                    var startForBattery = maxLength + 20 < 45 ? 45 : maxLength + 20;
                    var batteryDetails = renderDetails("", BatteryDynamicList === null || BatteryDynamicList === void 0 || (_BatteryDynamicList$ = BatteryDynamicList[0]) === null || _BatteryDynamicList$ === void 0 ? void 0 : _BatteryDynamicList$.Questions, startX + startForBattery, startY, 17, 20, 30);
                    var vehiclePrecheckStartY = startY;
                    if ((BatteryDynamicList === null || BatteryDynamicList === void 0 || (_BatteryDynamicList$2 = BatteryDynamicList[0]) === null || _BatteryDynamicList$2 === void 0 ? void 0 : _BatteryDynamicList$2.Questions.length) === 1) {
                        vehiclePrecheckStartY = batteryDetails - 5;
                    }
                    else if ((BatteryDynamicList === null || BatteryDynamicList === void 0 || (_BatteryDynamicList$3 = BatteryDynamicList[0]) === null || _BatteryDynamicList$3 === void 0 ? void 0 : _BatteryDynamicList$3.Questions.length) === 0 || (BatteryDynamicList === null || BatteryDynamicList === void 0 || (_BatteryDynamicList$4 = BatteryDynamicList[0]) === null || _BatteryDynamicList$4 === void 0 ? void 0 : _BatteryDynamicList$4.Questions.length) === undefined) {
                        vehiclePrecheckStartY = batteryDetails;
                    }
                    else {
                        vehiclePrecheckStartY = batteryDetails - 10;
                    }
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(7);
                    var label = 'D - Damage | S - Scratch | M - Missing';
                    var centerWidth = 96;
                    var textWidth = doc.getTextWidth(label);
                    var centeredX = startX + centerWidth / 2 - textWidth / 2;
                    doc.text(label, centeredX, vehiclePrecheckStartY + 18);
                    // doc.text('D - Damage | S - Scratch |  M - Missing', startX + 30, vehiclePrecheckStartY + 18);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(7);
                    var borderStartY = vehiclePrecheckStartY + 13;
                    var checkboxGap = 0;
                    var lineHeight = 6;
                    var boxSize = 4;
                    var columnGap = 55;
                    var yLeft = vehiclePrecheckStartY + 30;
                    var yRight = vehiclePrecheckStartY + 30;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(7);
                    doc.text("L", startX + 27 + checkboxGap, yLeft - 5);
                    doc.text("T", startX + 33 + checkboxGap, yLeft - 5);
                    doc.text("R", startX + 39 + checkboxGap, yLeft - 5);
                    doc.setDrawColor(0);
                    if (Array.isArray(itemsLeft)) {
                        itemsLeft === null || itemsLeft === void 0 || itemsLeft.forEach(function (item) {
                            doc.setFont("helvetica", "normal");
                            doc.text((item === null || item === void 0 ? void 0 : item.name) || '', startX - 1, yLeft, {
                                maxWidth: 25
                            });
                            doc.rect(startX + 26 + checkboxGap, yLeft - 3, boxSize + 0.5, boxSize + 1); // L
                            doc.rect(startX + 32 + checkboxGap, yLeft - 3, boxSize + 0.5, boxSize + 1); // R
                            doc.rect(startX + 38 + checkboxGap, yLeft - 3, boxSize + 0.5, boxSize + 1); // T
                            doc.setFont("helvetica", "bold");
                            // if (item.pos === 'L') {
                            //     doc.text(item.mark || '', startX + 27 + checkboxGap, yLeft + 0.5); // shifted -4
                            // } else if (item.pos === 'T' || item.pos === 'F') {
                            //     doc.text(item.mark || '', startX + 33 + checkboxGap, yLeft + 0.5); // shifted -4
                            // } else if (item.pos === 'R') {
                            //     doc.text(item.mark || '', startX + 39.5 + checkboxGap, yLeft + 0.5); // shifted -4
                            // }
                            doc.text((item === null || item === void 0 ? void 0 : item.L) || '', startX + 27 + checkboxGap, yLeft + 0.5);
                            doc.text((item === null || item === void 0 ? void 0 : item.T) || (item === null || item === void 0 ? void 0 : item.F) || '', startX + 33 + checkboxGap, yLeft + 0.5);
                            doc.text((item === null || item === void 0 ? void 0 : item.R) || '', startX + 39.5 + checkboxGap, yLeft + 0.5);
                            yLeft += lineHeight;
                        });
                    }
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(7);
                    doc.text("L", startX + columnGap + 20 + checkboxGap, yRight - 5);
                    doc.text("T", startX + columnGap + 26 + checkboxGap, yRight - 5);
                    doc.text("R", startX + columnGap + 32 + checkboxGap, yRight - 5);
                    if (Array.isArray(itemsRight)) {
                        itemsRight === null || itemsRight === void 0 || itemsRight.forEach(function (item) {
                            doc.setFont("helvetica", "normal");
                            doc.text((item === null || item === void 0 ? void 0 : item.name) || '', startX + columnGap - 10, yRight, {
                                maxWidth: 27
                            });
                            doc.rect(startX + columnGap + 19 + checkboxGap, yRight - 3, boxSize + 0.5, boxSize + 1);
                            doc.rect(startX + columnGap + 25 + checkboxGap, yRight - 3, boxSize + 0.5, boxSize + 1);
                            doc.rect(startX + columnGap + 31 + checkboxGap, yRight - 3, boxSize + 0.5, boxSize + 1);
                            doc.setFont("helvetica", "bold");
                            // if (item.pos === 'L') {
                            //     doc.text(item.mark || '', startX + columnGap + 20.5 + checkboxGap, yRight + 0.5);
                            // } else if (item.pos === 'T' || item.pos === 'F') {
                            //     doc.text(item.mark || '', startX + columnGap + 26.5 + checkboxGap, yRight + 0.5);
                            // } else if (item.pos === 'R') {
                            //     doc.text(item.mark || '', startX + columnGap + 32.5 + checkboxGap, yRight + 0.5);
                            // }
                            doc.text((item === null || item === void 0 ? void 0 : item.L) || '', startX + columnGap + 20.5 + checkboxGap, yRight + 0.5);
                            doc.text((item === null || item === void 0 ? void 0 : item.T) || (item === null || item === void 0 ? void 0 : item.F) || '', startX + columnGap + 26.5 + checkboxGap, yRight + 0.5);
                            doc.text((item === null || item === void 0 ? void 0 : item.R) || '', startX + columnGap + 32.5 + checkboxGap, yRight + 0.5);
                            yRight += lineHeight;
                        });
                    }
                    var sectionWidth = columnGap * 2 - 14;
                    var sectionHeight = Math.max(yLeft, yRight) - borderStartY;
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.1);
                    doc.rect(startX - 2, borderStartY, sectionWidth, sectionHeight);
                    var observationY = borderStartY + sectionHeight + 5;
                    var observationBoxHeight = pageHeight - footerHeight - headerHeight - sectionHeight - 18;
                    doc.setFontSize(7);
                    doc.setFont("helvetica", "bold");
                    var availableHeightForObservation = pageHeight - observationY - footerHeight;
                    doc.setGState;
                    var minHeightForObservation = 8;
                    if (availableHeightForObservation >= minHeightForObservation) {
                        doc.text('Vehicle Inventory Observation:', startX - 2, observationY - 1);
                        doc.setDrawColor('#000000');
                        doc.setLineWidth(0.1);
                        doc.rect(startX - 2, observationY + 1, sectionWidth, observationBoxHeight - 0.5);
                        doc.setFont("helvetica", "normal");
                        doc.setFontSize(6);
                        doc.text(truncateTextToBox(doc, saObservation, sectionWidth - 5, observationBoxHeight) || '', startX, observationY + 4, {
                            maxWidth: sectionWidth - 2
                        });
                    }
                    else {
                        observationOnNextPage = true;
                    }
                };
                inspectionStartX = 195;
                pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
                customerComplaintStart = 0;
                if (pageNumber === 1) {
                    lineHeightCust = 4;
                    pageWidth_1 = doc.internal.pageSize.getWidth();
                    startY = 5;
                    lineHeight = 4;
                    logoWidth_1 = (SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) === 'Triumph' ? 20 : 15;
                    logoHeight_1 = 7;
                    logoX_1 = 10;
                    logoY_1 = startY;
                    doc.addImage(logoBase64, "PNG", logoX_1, logoY_1, logoWidth_1, logoHeight_1);
                    doc.setFontSize(12);
                    doc.setFont("helvetica", "bold");
                    doc.text("JOB CARD", pageWidth_1 / 2, logoY_1 + logoHeight_1 / 2, {
                        align: "center"
                    });
                    regBoxPaddingX = 4;
                    regText = "Registration No.";
                    doc.setFontSize(7);
                    labelWidth = doc.getTextWidth(regText + '  : ');
                    boxWidth = 45;
                    boxheight = 5;
                    boxX = doc.internal.pageSize.getWidth() - boxWidth - 10;
                    boxY = 5;
                    doc.setDrawColor(0);
                    doc.setLineWidth(0.132);
                    doc.rect(boxX, boxY, boxWidth, boxheight);
                    doc.setFontSize(7);
                    doc.text(regText + '  : ', boxX + regBoxPaddingX, boxY + 3.2);
                    doc.setFont("helvetica", "normal");
                    doc.text((_installbaseDetailsBy21 = installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy22 = installbaseDetailsById.data) === null || _installbaseDetailsBy22 === void 0 ? void 0 : _installbaseDetailsBy22.RegistrationNo) !== null && _installbaseDetailsBy21 !== void 0 ? _installbaseDetailsBy21 : '', boxX + regBoxPaddingX + labelWidth, boxY + 3.2);
                    baseY = logoY_1 + logoHeight_1 + 4;
                    leftX = 10;
                    leftY = baseY;
                    doc.setFontSize(7);
                    doc.setFont("helvetica", "bold");
                    orgNameLines = doc.splitTextToSize((selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationName) || '', 45);
                    orgNameY = leftY;
                    doc.text(orgNameLines, leftX, leftY);
                    doc.setFont("helvetica", "normal");
                    addressStartY = orgNameY + orgNameLines.length * 3;
                    doc.setFont("helvetica", "normal");
                    doc.text((_organizationAddress3 = organizationAddress) !== null && _organizationAddress3 !== void 0 ? _organizationAddress3 : '', leftX, addressStartY, {
                        maxWidth: 40
                    });
                    doc.setLineWidth(0.132);
                    columnCount = 5;
                    sectionWidth = pageWidth_1 / columnCount;
                    customerX = sectionWidth;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(8);
                    doc.text("Customer Details:", customerX - 2, baseY + 0.5);
                    doc.setFontSize(7);
                    doc.setFont("helvetica", "normal");
                    startX_1 = customerX - 2;
                    currentY_1 = baseY + 5.5;
                    labelWidthCustomer_1 = 15;
                    valueWidthCustomer_1 = 40;
                    lineSpacingCustomer_1 = 3.5;
                    details = [["Name", truncateTextWithLines(doc, customer === null || customer === void 0 ? void 0 : customer.PersonName, valueWidthCustomer_1, 2)], ["Email", (customer === null || customer === void 0 || (_customer$PrimaryCont5 = customer.PrimaryContact) === null || _customer$PrimaryCont5 === void 0 ? void 0 : _customer$PrimaryCont5.Email) || ''], ["Contact No.", (customer === null || customer === void 0 || (_customer$PrimaryCont6 = customer.PrimaryContact) === null || _customer$PrimaryCont6 === void 0 ? void 0 : _customer$PrimaryCont6.MobileNumber) || ''], ["Address", (function (_truncateAddress2, _lines, _lines3) {
                                var address = (customer === null || customer === void 0 ? void 0 : customer.Address) || '';
                                var truncated = ((_truncateAddress2 = truncateAddress(address, 80)) === null || _truncateAddress2 === void 0 ? void 0 : _truncateAddress2.replace(/,(\S)/g, ', $1')) || '';
                                var tempDoc = doc; // use the same doc instance for splitTextToSize
                                var lines = tempDoc === null || tempDoc === void 0 ? void 0 : tempDoc.splitTextToSize(truncated, 40);
                                if (((_lines = lines) === null || _lines === void 0 ? void 0 : _lines.length) > 3) {
                                    var _lines2;
                                    lines = (_lines2 = lines) === null || _lines2 === void 0 ? void 0 : _lines2.slice(0, 3);
                                    if (!lines[2].endsWith('...')) {
                                        lines[2] = lines[2].replace(/(.{0,37}).*/, '$1...'); // ensure max width
                                    }
                                }
                                return (_lines3 = lines) === null || _lines3 === void 0 ? void 0 : _lines3.join('\n');
                            })()]];
                    details === null || details === void 0 || details.forEach(function (_ref9) {
                        var label = _ref9[0], value = _ref9[1];
                        if (typeof value === 'string') {
                            var _value, _value2;
                            value = (_value = value) === null || _value === void 0 ? void 0 : _value.trimStart();
                            if ((_value2 = value) !== null && _value2 !== void 0 && _value2.startsWith('\n')) {
                                var _value3;
                                value = (_value3 = value) === null || _value3 === void 0 ? void 0 : _value3.replace(/^\n+/, '');
                            }
                        }
                        doc.setFont("helvetica", "bold");
                        doc.text(label, startX_1, currentY_1, {
                            maxWidth: labelWidthCustomer_1
                        });
                        doc.setFont("helvetica", "normal");
                        var valueLines = [];
                        if (typeof value === 'string') {
                            valueLines = doc.splitTextToSize(": ".concat(String(value)), valueWidthCustomer_1);
                        }
                        else {
                            valueLines = [": ".concat(String(value))];
                        }
                        valueLines.forEach(function (line, idx) {
                            doc.text(line, startX_1 + labelWidthCustomer_1, currentY_1 + idx * (lineSpacingCustomer_1 - 0.5), {
                                maxWidth: valueWidthCustomer_1
                            });
                        });
                        currentY_1 += valueLines.length * lineSpacingCustomer_1;
                    });
                    finalCustomerDetailsY = currentY_1;
                    vehicleX = sectionWidth * 2;
                    vehicleY = renderDetails("Vehicle Details:", [["Model Name", "".concat((installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy23 = installbaseDetailsById.data) === null || _installbaseDetailsBy23 === void 0 ? void 0 : _installbaseDetailsBy23.ProductName) || '', " ").concat(installbaseDetailsById !== null && installbaseDetailsById !== void 0 && (_installbaseDetailsBy24 = installbaseDetailsById.data) !== null && _installbaseDetailsBy24 !== void 0 && _installbaseDetailsBy24.ProductCode ? "(".concat(installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy25 = installbaseDetailsById.data) === null || _installbaseDetailsBy25 === void 0 ? void 0 : _installbaseDetailsBy25.ProductCode, ")") : '')], ["Reg. No.", (installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy26 = installbaseDetailsById.data) === null || _installbaseDetailsBy26 === void 0 ? void 0 : _installbaseDetailsBy26.RegistrationNo) || ''], ["Chassis No.", (installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy27 = installbaseDetailsById.data) === null || _installbaseDetailsBy27 === void 0 ? void 0 : _installbaseDetailsBy27.VinNo) || ''], ["Engine No.", (installbaseDetailsById === null || installbaseDetailsById === void 0 || (_installbaseDetailsBy28 = installbaseDetailsById.data) === null || _installbaseDetailsBy28 === void 0 ? void 0 : _installbaseDetailsBy28.EngineNo) || ''], ["Date of Sale", installbaseDetailsById !== null && installbaseDetailsById !== void 0 && (_installbaseDetailsBy29 = installbaseDetailsById.data) !== null && _installbaseDetailsBy29 !== void 0 && _installbaseDetailsBy29.SalesInvoiceDate ? dateFormate(installbaseDetailsById === null || installbaseDetailsById === void 0 ? void 0 : installbaseDetailsById.data.SalesInvoiceDate) : "-"]], vehicleX - 2, baseY, 15, 20, 35);
                    jobCardX = sectionWidth * 3;
                    jobCardY = renderDetails("Job Card Details:", [["Job Card No.", (_data$SourceDocumentN3 = data === null || data === void 0 ? void 0 : data.SourceDocumentNo) !== null && _data$SourceDocumentN3 !== void 0 ? _data$SourceDocumentN3 : ''], ["Service Type", (_data$RepairTypeName2 = data === null || data === void 0 ? void 0 : data.RepairTypeName) !== null && _data$RepairTypeName2 !== void 0 ? _data$RepairTypeName2 : ''], ["Total KMs Reading", TotalKMReading !== null && TotalKMReading !== void 0 ? TotalKMReading : ''], ["Expected Start Time ", ""]], jobCardX - 7, baseY, 25, 35, 28);
                    serviceX = sectionWidth * 4;
                    renderDetails("", [["Job Card Date & Time", (_dayjs$format2 = dayjs(data === null || data === void 0 ? void 0 : data.JobCardDate).format("DD MMM, YYYY hh:mm A")) !== null && _dayjs$format2 !== void 0 ? _dayjs$format2 : ''], ["Current KMs Reading", (_data$ODOMeterReading2 = data === null || data === void 0 ? void 0 : data.ODOMeterReading) !== null && _data$ODOMeterReading2 !== void 0 ? _data$ODOMeterReading2 : ''], ["Odometer Replaced On", ''], ["Estimate Delivery Time", "".concat(dayjs(EstimateDetails === null || EstimateDetails === void 0 ? void 0 : EstimateDetails.DeliveryDate).format('DD MMM, YYYY hh:mm A'))]], serviceX - 7, baseY, 30, 40, 30);
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.132);
                    dividerX = sectionWidth - 5;
                    dividerY = Math.max(leftY, vehicleY, jobCardY) + lineHeight;
                    doc.line(dividerX, baseY - logoHeight_1 + 2, dividerX, dividerY - 2);
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.264);
                    LastY = Math.max(finalCustomerDetailsY, dividerY);
                    divider2Y = LastY;
                    doc.line(10, LastY, pageWidth_1 - 10, LastY);
                    inspectionStartY = headerHeight - 1;
                    dividerEndY = pageHeight - footerHeight - 1;
                    dividerXForLine = 190;
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.132);
                    doc.line(dividerXForLine, divider2Y ? divider2Y : LastY, dividerXForLine, dividerEndY);
                    drawVehicleInspectionSection(doc, inspectionStartX, LastY + 4);
                    revisitedX = 10;
                    revisitedY = renderDetails("Other Details:", [["Revisited", isRevisited ? 'Yes' : 'No'], ["Last NPS Feedback", category !== null && category !== void 0 ? category : ''], ["Hex File Update", ""], ["Open Complaint", ""]], revisitedX, LastY + 4, 30, 40, 15);
                    CampaignX = sectionWidth - 5;
                    CampaignY = renderDetails("", [["No. of Complaints In Last 6 Months", ''], ["Campaign ", (data === null || data === void 0 ? void 0 : data.CampaignName) || ''], ["Lost Customer", ""]], CampaignX + 3, LastY + 4, 42, 42, 25);
                    NPSX = sectionWidth * 2;
                    NPSY = renderDetails("", [["AMC Expiry Date", installbaseContracts !== null && installbaseContracts !== void 0 && installbaseContracts.AMCExpiryDate ? dayjs.utc(installbaseContracts === null || installbaseContracts === void 0 ? void 0 : installbaseContracts.AMCExpiryDate).format('DD MMM, YYYY') : ''], ["EW / ATW Expiry Date", installbaseContracts !== null && installbaseContracts !== void 0 && installbaseContracts.ATWExpiryDate ? dayjs.utc(installbaseContracts === null || installbaseContracts === void 0 ? void 0 : installbaseContracts.ATWExpiryDate).format('DD MMM, YYYY') : ''], ["RSA Expiry Date", ""]], NPSX + 10, LastY + 4, 30, 30);
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.132);
                    divider2Y = Math.max(leftY, revisitedY, CampaignY, NPSY, LastY + 4);
                    doc.line(10, divider2Y + 3, 187, divider2Y + 3);
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(8);
                    doc.text("Customer Voice:", 10, divider2Y + 8);
                    doc.setFont("helvetica", "normal");
                    customerComplaint = ((data === null || data === void 0 || (_data$CustomerVoice2 = data.CustomerVoice) === null || _data$CustomerVoice2 === void 0 || (_data$CustomerVoice2 = _data$CustomerVoice2[0]) === null || _data$CustomerVoice2 === void 0 ? void 0 : _data$CustomerVoice2.CustomerComplaint) || '').replace(/\s+/g, ' ') || "";
                    lines = doc.splitTextToSize(customerComplaint, 150);
                    // const complaintText = truncateTextWithLines(doc, customerComplaint, 150, 3) || '';
                    // doc.text(complaintText, 35, divider2Y + 8, { maxWidth: 150 });
                    doc.text(lines, 33, divider2Y + 8, {
                        maxWidth: 150
                    });
                    complaintHeight = (lines === null || lines === void 0 ? void 0 : lines.length) * 3;
                    customerComplaintEndY = divider2Y + 7 + complaintHeight;
                    customerComplaintStart = customerComplaintEndY;
                }
                renderTable({
                    title: "",
                    data: customerComplsints,
                    columns: CustomerVoiceColumns,
                    startY: customerComplaintStart,
                    tableWidth: 177,
                    isHideTotalRow: true,
                    customColumnWidths: {
                        0: {
                            cellWidth: 9,
                            halign: 'center'
                        },
                        5: {
                            cellWidth: 18,
                            halign: 'center'
                        },
                        6: {
                            cellWidth: 18,
                            halign: 'center'
                        },
                        7: {
                            cellWidth: 18,
                            halign: 'center'
                        }
                    }
                });
                doc.setFont("helvetica", "bold");
                doc.setFontSize(8);
                thresholdHeight = 50;
                afterCustomerVoiceY = doc.lastAutoTable.finalY;
                customerVoiceEndPage = doc.internal.getCurrentPageInfo().pageNumber;
                alocationDetailsY = 0;
                availableHeight = pageHeight - afterCustomerVoiceY - footerHeight;
                if (availableHeight < thresholdHeight) {
                    doc.addPage();
                    isCustomerVoiceOnNextPage = true;
                    // currentPage = (doc.internal as any).getCurrentPageInfo().pageNumber;
                    afterCustomerVoiceY = 10;
                    alocationDetailsY = 30;
                }
                if (customerVoiceEndPage >= 2) {
                    alocationDetailsY = 30;
                    isCustomerVoiceOnNextPage = true;
                }
                startingPageVisitVisitedDetails = doc.internal.getCurrentPageInfo().pageNumber;
                renderTable({
                    title: "Last 2 Visits Details:",
                    data: lastTwoServices,
                    columns: last2VisitColumns,
                    startY: afterCustomerVoiceY + 5,
                    tableWidth: 87.5,
                    marginLeft: 10,
                    isHideTotalRow: true,
                    customColumnWidths: {
                        0: {
                            cellWidth: 17
                        }
                    }
                });
                last2VisitsTableY = doc.lastAutoTable.finalY;
                EstimationDetails = [{
                        id: 1,
                        TotalPartAmount: EstimatePartTotal.toFixed(2),
                        TotalLabourAmount: EstimateLabourTotal.toFixed(2),
                        PartAndLabourTotal: GrandTotal,
                        EstimateDeliveryDate: EstimateDetails !== null && EstimateDetails !== void 0 && EstimateDetails.DeliveryDate ? dayjs(EstimateDetails === null || EstimateDetails === void 0 ? void 0 : EstimateDetails.DeliveryDate).format('DD MMM, YYYY hh:mm a') : ''
                    }];
                doc.setPage(startingPageVisitVisitedDetails);
                renderTable({
                    title: "Estimation Details :",
                    data: EstimationDetails,
                    columns: estimationColumns,
                    startY: afterCustomerVoiceY + 5,
                    tableWidth: 88,
                    marginLeft: 99,
                    isHideTotalRow: true,
                    customColumnWidths: {
                        0: {
                            halign: 'center'
                        },
                        1: {
                            halign: 'center'
                        },
                        2: {
                            halign: 'center'
                        }
                    }
                });
                estimateTableY = doc.lastAutoTable.finalY;
                allocationStartY = last2VisitsTableY > estimateTableY ? last2VisitsTableY + 5 : estimateTableY + 5;
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                doc.text("Allocation Details:", 10, allocationStartY);
                doc.setFont("helvetica", "normal");
                allocationDetails = [{
                        label: "Service Advisor",
                        value: (_data$ServiceAdvisorN = data === null || data === void 0 ? void 0 : data.ServiceAdvisorName) !== null && _data$ServiceAdvisorN !== void 0 ? _data$ServiceAdvisorN : '',
                        x: 10
                    }, {
                        label: "Technician Name",
                        value: (_data$TechnicianName = data === null || data === void 0 ? void 0 : data.TechnicianName) !== null && _data$TechnicianName !== void 0 ? _data$TechnicianName : '',
                        x: 90
                    }, {
                        label: "Floor Supervisor",
                        value: (_data$FloorSupervisor = data === null || data === void 0 ? void 0 : data.FloorSupervisorName) !== null && _data$FloorSupervisor !== void 0 ? _data$FloorSupervisor : '',
                        x: 10,
                        yOffset: 4
                    }, {
                        label: "Final Inspection By",
                        value: finalInspector !== null && finalInspector !== void 0 ? finalInspector : '',
                        x: 90,
                        yOffset: 4
                    }];
                if (Array.isArray(allocationDetails)) {
                    allocationDetails === null || allocationDetails === void 0 || allocationDetails.forEach(function (item, index) {
                        var y = allocationStartY + (item.yOffset || 0);
                        doc.text("".concat(item.label, " "), item.x, y + 5);
                        doc.text(": ".concat(item.value), item.x + 30, y + 5, {
                            maxWidth: 50
                        });
                    });
                }
                afterLabourTableY = doc.lastAutoTable.finalY;
                currentPage = doc.internal.getNumberOfPages();
                if (currentPage === 1) {
                    doc.addPage();
                    afterLabourTableY = 17;
                    currentPage = doc.internal.getNumberOfPages();
                }
                remainingHeight = pageHeight - afterLabourTableY - footerHeight - 20;
                estimatedTableHeight = 30;
                if (remainingHeight < estimatedTableHeight) {
                    doc.addPage();
                    afterLabourTableY = 17;
                }
                startingPage = doc.internal.getCurrentPageInfo().pageNumber;
                headerHeight = 20;
                if (observationOnNextPage) {
                    sectionWidth = 94;
                    observationY = 22;
                    observationBoxHeight = 20;
                    startX = 195;
                    // headerHeight = headerHeight + observationY
                    doc.text('Vehicle Inventory Observation:', startX - 2, observationY - 1);
                    doc.setDrawColor('#000000');
                    doc.setLineWidth(0.1);
                    doc.rect(startX - 2, observationY + 1, sectionWidth, observationBoxHeight - 0.5);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(6);
                    doc.text(truncateTextToBox(doc, saObservation, sectionWidth - 5, observationBoxHeight) || '', startX, observationY + 4, {
                        maxWidth: sectionWidth - 2
                    });
                }
                customerVoiceHeight = 0;
                if (observationOnNextPage) {
                    customerVoiceHeight = isCustomerVoiceOnNextPage ? 0 : 25;
                }
                renderTable({
                    title: "Parts :",
                    data: formattedPartDetails,
                    columns: PartColumns,
                    startY: afterLabourTableY + alocationDetailsY - 4 + customerVoiceHeight,
                    tableWidth: pageWidth / 2 - 11,
                    customColumnWidths: {
                        0: {
                            halign: 'center'
                        },
                        3: {
                            halign: 'center'
                        },
                        4: {
                            halign: 'center'
                        }
                    }
                });
                partTableY = doc.lastAutoTable.finalY;
                startingPageAfterPartTable = doc.internal.getCurrentPageInfo().pageNumber;
                doc.setPage(startingPage);
                renderTable({
                    title: "Labour :",
                    data: formattedLabourDetails,
                    columns: LabourColumns,
                    startY: afterLabourTableY + alocationDetailsY - 4 + customerVoiceHeight,
                    tableWidth: pageWidth / 2 - 12,
                    marginLeft: pageWidth / 2 + 2,
                    customColumnWidths: {
                        0: {
                            halign: 'center'
                        },
                        3: {
                            halign: 'center'
                        },
                        4: {
                            halign: 'center'
                        }
                    }
                });
                labourTableY = doc.lastAutoTable.finalY;
                startingPageAfterLabourTable = doc.internal.getCurrentPageInfo().pageNumber;
                declarationHeight = 40;
                declarationY = pageHeight - footerHeight - declarationHeight;
                if (partTableY > declarationY) {
                    doc.addPage();
                    addOtherPagesHeader(doc);
                    addOtherPageFooter(doc);
                    declarationY = pageHeight - footerHeight - declarationHeight;
                    startingPageAfterPartTable = startingPageAfterPartTable + 1;
                }
                if (labourTableY > declarationY) {
                    startingPageAfterLabourTable = startingPageAfterLabourTable + 1;
                }
                marginL = 10;
                declarationHeightY = pageHeight - footerHeight - 25;
                doc.setPage(startingPageAfterPartTable > startingPageAfterLabourTable ? startingPageAfterPartTable : startingPageAfterLabourTable);
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                declaration = "I hereby authorise workshop to execute all the above listed jobs using parts & consumable at my cost. I agree with all Terms & Conditions. I also understand that vehicle is being stored, repaired & test driven at my risk.";
                doc.text("Declaration", marginL, declarationHeightY);
                doc.setFontSize(8);
                doc.setFont("helvetica", "normal");
                doc.text(doc.splitTextToSize(declaration, pageWidth - 2 * marginL), marginL, declarationHeightY + 5);
                signatureY = declarationHeightY + 18;
                serviceAdvisorX = pageWidth / 2 + 10;
                doc.text("Customer Signature", marginL, signatureY + 1);
                doc.text("Service Advisor Signature", pageWidth / 2 + 10, signatureY + 1);
                customerLineStartX = marginL + 60;
                customerLineEndX = serviceAdvisorX - 5;
                logoWidth = 15;
                logoHeight = 7;
                lineCenterX = (customerLineStartX + customerLineEndX) / 2;
                logoX = lineCenterX - logoWidth / 2;
                logoY = signatureY - logoHeight - 1;
                if (customerSignature) {
                    doc.addImage(customerSignature, "PNG", logoX, logoY, logoWidth, logoHeight);
                }
                else {
                    console.warn("Customer signature is not available.");
                }
                doc.line(customerLineStartX, signatureY + 1, customerLineEndX, signatureY + 1);
                advisorLineWidth = 70;
                advisorLineEndX = pageWidth - 10;
                advisorLineStartX = advisorLineEndX - advisorLineWidth;
                doc.line(advisorLineStartX, signatureY + 1, advisorLineEndX, signatureY + 1);
                doc.setFontSize(12);
                doc.setFont("helvetica", "bold");
                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                doc.setFontSize(11);
                doc.setFont("helvetica", "normal");
                if (mode === 'download') {
                    doc.save('JobCardPrint.pdf');
                }
                else if (mode === 'print') {
                    isMobile_1 = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                    pdfBlob = doc.output('blob');
                    blobUrl = URL.createObjectURL(pdfBlob);
                    if (isMobile_1) {
                        newWindow = window.open(blobUrl);
                        if (newWindow) {
                            newWindow.focus();
                        }
                    }
                    else {
                        iframe_1 = document.createElement('iframe');
                        iframe_1.style.display = 'none';
                        iframe_1.src = blobUrl;
                        document.body.appendChild(iframe_1);
                        iframe_1.onload = function () {
                            var _iframe$contentWindow, _iframe$contentWindow2;
                            (_iframe$contentWindow = iframe_1.contentWindow) === null || _iframe$contentWindow === void 0 || _iframe$contentWindow.focus();
                            (_iframe$contentWindow2 = iframe_1.contentWindow) === null || _iframe$contentWindow2 === void 0 || _iframe$contentWindow2.print();
                        };
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            rowGap: '20px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    display: 'flex',
                    justifyContent: 'space-between',
                    columnSize: 12,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'JobCardPrint.pdf',
                            columnSize: 0,
                            fontSize: 'xl',
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                fontSize: "small",
                                color: "secondary"
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            },
                            size: 'small',
                            color: 'secondary'
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            gap: 1.5,
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'end',
            spacing: 0,
            sx: {
                paddingTop: '24px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: isSearchLoading ? /*#__PURE__*/ React.createElement(CircularProgress, {
                        size: 20
                    }) : 'Download',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'outlined',
                    color: 'primary',
                    disabled: isSearchLoading,
                    onClick: function () {
                        generatePDF('download');
                    }
                    // setFormState: async (state, e) => {
                    //     const res = await dispatch(showSurface({
                    //         type: 'Menu',
                    //         Component: ActionMenuList,
                    //         containerProps: {
                    //             anchorEl: e?.target,
                    //         },
                    //         componentProps: {
                    //             items: [
                    //                 {
                    //                     id: 'CustomerPrint',
                    //                     children: [, "CustomerPrint.pdf"]
                    //                 },
                    //             ]
                    //         } as any
                    //     }));
                    //     if (res?.payload === 'CustomerPrint') {
                    //         generatePDF('download')
                    //     }
                    // },
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: isSearchLoading ? /*#__PURE__*/ React.createElement(CircularProgress, {
                        size: 20,
                        color: "secondary"
                    }) : 'Print',
                    onClick: function () {
                        generatePDF('print');
                    },
                    color: 'primary',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'contained',
                    disabled: isSearchLoading
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        gridProps: {
            p: 2,
            gap: 2,
            spacing: 0
        }
    });
};
